var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandTreat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-orthopedic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-orthopedic:not(.animated) .animable {opacity: 0;}svg#freepik_stories-orthopedic.animated #freepik--speech-bubble--inject-57 {animation: 3s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-57",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "249.998px 351.987px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-57",
    d: "M78.17,252.78c-94.9,54.79-94.9,143.62,0,198.41s248.77,54.79,343.66,0,94.9-143.62,0-198.41S173.06,198,78.17,252.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.998px 351.987px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 157.71px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--diplomas--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 181.415px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 181.415px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 181.415px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.15 208.27 40.65 209.13 78.14 187.49 76.64 186.62 39.15 208.27",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.645px 197.875px"
    },
    id: "ellr1j3fhepxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.64 186.62 40.65 207.4 40.65 176.21 76.64 155.43 76.64 186.62",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.645px 181.415px"
    },
    id: "elbn3r2o6ud5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.64,152,39.15,175.34v36.39l40.49-23.38Zm-1.5,35.52L40.65,209.13V176.21l37.49-21.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "59.395px 181.865px"
    },
    id: "elvyiekgzlv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.14 187.49 76.64 186.62 76.64 155.43 78.14 154.56 78.14 187.49",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.39px 171.025px"
    },
    id: "elrxe0hyt23w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.64 151.97 78.14 151.1 37.65 174.48 39.15 175.34 79.64 151.97",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "58.645px 163.22px"
    },
    id: "el6cdsfvcgjqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.65 174.48 39.15 175.34 39.15 211.73 37.65 210.86 37.65 174.48",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "38.4px 193.105px"
    },
    id: "elbgug0hms3wl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,180c1.61-.94,2.92-.38,2.92,1.23a6.06,6.06,0,0,1-2.92,4.61c-1.62.93-2.93.38-2.93-1.23A6,6,0,0,1,71.49,180Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "71.485px 182.918px"
    },
    id: "el362smsx7guj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,175.18l22-12.71c.62-.35,1.11-.14,1.11.47V163a2.28,2.28,0,0,1-1.11,1.75l-22,12.72c-.61.36-1.11.15-1.11-.46v-.07A2.32,2.32,0,0,1,47.87,175.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.87px 169.973px"
    },
    id: "elv34x6ztcmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,184.12l29-16.72c.61-.35,1.11-.25,1.11.23a2.13,2.13,0,0,1-1.11,1.5l-29,16.74c-.61.35-1.1.25-1.09-.23A2.16,2.16,0,0,1,44.38,184.12Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 176.635px"
    },
    id: "eljm6a33dt3zj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,187.58l29-16.72c.61-.35,1.11-.25,1.11.23a2.13,2.13,0,0,1-1.11,1.5l-29,16.74c-.61.35-1.1.25-1.09-.23A2.16,2.16,0,0,1,44.38,187.58Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 180.095px"
    },
    id: "elu075uyk5y8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,191l29-16.72c.61-.35,1.11-.25,1.11.23a2.13,2.13,0,0,1-1.11,1.5l-29,16.74c-.61.35-1.1.25-1.09-.24A2.17,2.17,0,0,1,44.38,191Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 183.515px"
    },
    id: "elponjdh9l3jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29,187.75a1.88,1.88,0,0,1-.73.22c-.62.06-.56-.5-.54-.88,0-.17-.26-.41-.41-.17-.37.61-.85,1.19-1.25,1.8-.25.37-.72,1.19-1.32,1.12-.24,0-.32-.25-.32-.53a2.63,2.63,0,0,0,.38-1.6c0-.16-.34-.33-.44-.1a4.64,4.64,0,0,0-.37,1.46,9.38,9.38,0,0,1-.94,1.28c-.2.25-.38.52-.6.76,0,0-.15.19-.24.21s-.18-.06-.21-.17a1.13,1.13,0,0,1,.1-.53h0v0h0c0-.17-.25-.41-.35-.19a8.48,8.48,0,0,1-1.7,2.59l-.11.09c0-.1,0-.2-.05-.3a2.15,2.15,0,0,0-.13-.67c-.05-.11-.27-.26-.39-.1a13.17,13.17,0,0,1-1.93,2.45l-.4.28c-.13-.06.07-.68.1-.78.08-.27.18-.55.28-.82a2.48,2.48,0,0,0,.23-.68c0-.21-.37-.5-.44-.22,0,.12-.15.4-.27.75a19.15,19.15,0,0,1-1.62,2.51,6.75,6.75,0,0,1-2.27,2.06c-.25.14-.73.36-1,.2s-.25-.46-.26-.69a5.38,5.38,0,0,1,.27-1.76,13.78,13.78,0,0,0,2.51-1.72,9.31,9.31,0,0,0,1.9-2c.26-.42.41-1.1-.21-1.28a2.06,2.06,0,0,0-1.36.39,6.71,6.71,0,0,0-1.38,1,7.42,7.42,0,0,0-1.72,2.87c-.06.16-.13.37-.2.61a6.3,6.3,0,0,1-3.19.71c-.06,0-.08.12,0,.12a6,6,0,0,0,3.12-.5c-.28,1.07-.44,2.47.69,2.65s2.49-1.14,3.09-1.89a11.25,11.25,0,0,0,1.21-1.79l.11-.13c0,.49.11.83.66.71s1.06-.85,1.37-1.24.55-.76.82-1.15c0,.44.14.93.63.81s.88-.88,1.11-1.19.38-.55.54-.83a.69.69,0,0,0,.11.13c.41.35.88-.09,1.14-.41s.78-.92,1.13-1.42a.74.74,0,0,0,.48.43c.62.21,1.2-.28,1.56-.7a13,13,0,0,0,1.16-1.72.68.68,0,0,0,.43.48,1.63,1.63,0,0,0,1.46-.19C66.68,188,66.49,187.65,66.29,187.75ZM52.73,190.9c.29-.15.89-.41.92,0,0,.24-.24.56-.39.76a11.12,11.12,0,0,1-1.68,1.68,16.64,16.64,0,0,1-2.11,1.56A6.68,6.68,0,0,1,52.73,190.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "56.1206px 192.513px"
    },
    id: "elnek0xxvgbgq",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diplomas--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 134.005px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 134.005px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "58.645px 134.005px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.15 160.85 40.65 161.72 78.14 140.08 76.64 139.21 39.15 160.85",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.645px 150.465px"
    },
    id: "ely7xtc6my978",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.64 139.21 40.65 159.99 40.65 128.8 76.64 108.02 76.64 139.21",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.645px 134.005px"
    },
    id: "elnelgu4slwjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.64,104.56,39.15,127.93v36.39l40.49-23.38Zm-1.5,35.52L40.65,161.72V128.8l37.49-21.65Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "59.395px 134.44px"
    },
    id: "elrho357qru7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.14 140.08 76.64 139.21 76.64 108.02 78.14 107.15 78.14 140.08",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.39px 123.615px"
    },
    id: "elcnmefywtg4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.64 104.56 78.14 103.69 37.65 127.06 39.15 127.93 79.64 104.56",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "58.645px 115.81px"
    },
    id: "elt0ysx9exb2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.65 127.06 39.15 127.93 39.15 164.32 37.65 163.45 37.65 127.06",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "38.4px 145.69px"
    },
    id: "el6j0l9x00rqr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,132.53c1.61-.93,2.92-.38,2.92,1.24a6.07,6.07,0,0,1-2.92,4.61c-1.62.93-2.93.38-2.93-1.24A6.08,6.08,0,0,1,71.49,132.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "71.485px 135.455px"
    },
    id: "eljzzi3z2ichn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,127.77l22-12.71c.62-.36,1.11-.15,1.11.46v.06a2.3,2.3,0,0,1-1.11,1.75l-22,12.72c-.61.35-1.11.14-1.11-.47v-.06A2.31,2.31,0,0,1,47.87,127.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.87px 122.551px"
    },
    id: "el33r2oyw6ltp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,136.71l29-16.72c.61-.35,1.11-.25,1.11.23a2.15,2.15,0,0,1-1.11,1.5l-29,16.74c-.61.35-1.1.24-1.09-.24A2.15,2.15,0,0,1,44.38,136.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 129.223px"
    },
    id: "eln5nhtk1o8we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,140.17l29-16.72c.61-.36,1.11-.25,1.11.22a2.15,2.15,0,0,1-1.11,1.51l-29,16.73c-.61.36-1.1.25-1.09-.23A2.15,2.15,0,0,1,44.38,140.17Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 132.68px"
    },
    id: "elfglws9hgnjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,143.63l29-16.72c.61-.36,1.11-.25,1.11.22a2.15,2.15,0,0,1-1.11,1.51l-29,16.73c-.61.36-1.1.25-1.09-.23A2.15,2.15,0,0,1,44.38,143.63Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "58.8899px 136.14px"
    },
    id: "elhcjxgsyw6ot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29,140.34a1.88,1.88,0,0,1-.73.22c-.62.06-.56-.5-.54-.88,0-.17-.26-.41-.41-.17-.37.61-.85,1.19-1.25,1.8-.25.36-.72,1.19-1.32,1.12-.24,0-.32-.25-.32-.54a2.6,2.6,0,0,0,.38-1.59c0-.16-.34-.34-.44-.11a4.71,4.71,0,0,0-.37,1.47,9.38,9.38,0,0,1-.94,1.28c-.2.25-.38.52-.6.75,0,.06-.15.2-.24.22s-.18-.06-.21-.18a1.07,1.07,0,0,1,.1-.52h0s0,0,0,0h0c0-.17-.25-.4-.35-.18a8.32,8.32,0,0,1-1.7,2.58l-.11.09a2.5,2.5,0,0,0-.05-.29,2.28,2.28,0,0,0-.13-.68c-.05-.1-.27-.25-.39-.1A12.91,12.91,0,0,1,54.74,147l-.4.28c-.13-.06.07-.68.1-.78.08-.28.18-.55.28-.83A2.38,2.38,0,0,0,55,145c0-.21-.37-.49-.44-.21,0,.12-.15.4-.27.75a19.84,19.84,0,0,1-1.62,2.51,6.75,6.75,0,0,1-2.27,2.06c-.25.14-.73.35-1,.2s-.25-.47-.26-.69a5.38,5.38,0,0,1,.27-1.76,13.35,13.35,0,0,0,2.51-1.73,8.86,8.86,0,0,0,1.9-2c.26-.42.41-1.09-.21-1.27a2.05,2.05,0,0,0-1.36.38,6.75,6.75,0,0,0-1.38,1,7.35,7.35,0,0,0-1.72,2.87c-.06.16-.13.37-.2.61a6.3,6.3,0,0,1-3.19.71c-.06,0-.08.11,0,.12a6.15,6.15,0,0,0,3.12-.5c-.28,1.07-.44,2.47.69,2.65s2.49-1.14,3.09-1.89a11.72,11.72,0,0,0,1.21-1.79.69.69,0,0,1,.11-.13c0,.49.11.83.66.71s1.06-.85,1.37-1.24.55-.76.82-1.15c0,.44.14.93.63.81s.88-.88,1.11-1.2.38-.54.54-.82l.11.13c.41.34.88-.09,1.14-.41s.78-.92,1.13-1.42a.77.77,0,0,0,.48.43c.62.2,1.2-.28,1.56-.71a12.24,12.24,0,0,0,1.16-1.71.68.68,0,0,0,.43.48,1.66,1.66,0,0,0,1.46-.19C66.68,140.58,66.49,140.24,66.29,140.34Zm-13.56,3.14c.29-.14.89-.4.92,0,0,.25-.24.57-.39.77a11.6,11.6,0,0,1-1.68,1.68,15.65,15.65,0,0,1-2.11,1.55A6.74,6.74,0,0,1,52.73,143.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "56.1574px 145.063px"
    },
    id: "elno2a8fvpen",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Negatoscope--inject-57",
    className: "animable",
    style: {
      transformOrigin: "159.56px 102.67px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--negatoscope--inject-57",
    className: "animable",
    style: {
      transformOrigin: "159.56px 102.67px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--negatoscope--inject-57",
    className: "animable",
    style: {
      transformOrigin: "159.56px 102.67px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "158.295px 104.675px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "106.91 170.66 109.45 172.12 209.68 114.26 207.15 112.8 106.91 170.66",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "158.295px 142.46px"
    },
    id: "elx8bfjgx750d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.15 112.8 109.45 169.19 109.45 96.55 207.14 40.16 207.15 112.8",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "158.3px 104.675px"
    },
    id: "el06msr0aeigwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.21,34.31,106.91,95.09v81.42l105.3-60.78Zm-2.53,80L109.45,172.12V96.55L209.68,38.7Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "159.56px 105.41px"
    },
    id: "elk8zcg87mw0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.68 114.26 207.15 112.8 207.14 40.16 209.68 38.7 209.68 114.26",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "208.41px 76.48px"
    },
    id: "elaabx2uvqr2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.21 34.31 209.68 32.84 104.38 93.63 106.91 95.09 212.21 34.31",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "158.295px 63.965px"
    },
    id: "elj9d0d7rybr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.38 93.63 106.91 95.09 106.91 176.51 104.38 175.04 104.38 93.63",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "105.645px 135.07px"
    },
    id: "elg1siika9b5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "104.38 89.62 109.44 92.54 214.74 31.76 209.68 28.83 104.38 89.62",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "159.56px 60.685px"
    },
    id: "elndl81q3qoxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.44 92.54 109.44 100.56 214.74 39.78 214.74 31.76 109.44 92.54",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "162.09px 66.16px"
    },
    id: "elz6phf2ykkth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.38 89.62 109.44 92.54 109.44 100.56 104.38 97.64 104.38 89.62",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.91px 95.09px"
    },
    id: "el101r5xcnwx1p",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Xray--inject-57",
    className: "animable",
    style: {
      transformOrigin: "138.53px 114.596px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118,155.54V95.72L159.06,72v59.82a5.11,5.11,0,0,1-2.31,4l-36.5,21.07C119,157.61,118,157,118,155.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "138.53px 114.596px"
    },
    id: "eld4pf3cw2gr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,100.36a3.56,3.56,0,0,1-.84-1.26c-1.52-3.2-2.49-6.95-3.86-10.32l-5.71,3.3A72.06,72.06,0,0,1,136.74,103c.2.79.39,1.6.54,2.44a11.89,11.89,0,0,1,.2,3.37c-.11,1.2-.46,2.48-.53,3.66s.19,2.36,1,2.26,1.69-1.34,2.39-2.33c1.37-2,3.21-3.06,4.4-5.22a8,8,0,0,0,1-3.66,2.94,2.94,0,0,0-1-2.5C144.37,100.73,143.88,100.66,143.5,100.36Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "139.422px 101.758px"
    },
    id: "elnhixiz1lt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,111a6.47,6.47,0,0,0-1.54,2.29,2.35,2.35,0,0,0,.64,2.39,2.45,2.45,0,0,0,3.93-.07c1.42-1.62,1.62-5.46,1.67-7.21.08-2.36-1.09-3.76-2.57-.68a14.62,14.62,0,0,1-2.11,3.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "145.222px 111.29px"
    },
    id: "elkbjvewbwze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,144.75c0,.16,0,.32-.07.48l2.71-1.56a87.43,87.43,0,0,1,1.9-14.67,16.4,16.4,0,0,1,2.32-6.11c.87-1.18,2.07-2.4,2-.3a8.87,8.87,0,0,1-.48,2.11c-1.9,6.13-3.48,12.29-4.73,18.4l2.61-1.51c1.18-5.32,2.58-10.67,4.21-16a20.59,20.59,0,0,0,1.31-6.55,1.17,1.17,0,0,0-.17-.65c-.16-.17-.41-.13-.64-.11a2.62,2.62,0,0,1-2.33-1.06c-.44-.49-1-1.68-1.78-1.35-.37.15-.76.87-1.17,1s-.85-.2-1.34-.08a2.44,2.44,0,0,0-1.21,2.49,2.94,2.94,0,0,0,.44.68,5.64,5.64,0,0,1,.17,3.1C135.83,130.2,134.06,137.57,133,144.75Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "138.855px 130.522px"
    },
    id: "elijg0d3gn22",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--wall-cabinet--inject-57",
    className: "animable",
    style: {
      transformOrigin: "337.115px 89.03px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-57",
    className: "animable",
    style: {
      transformOrigin: "337.115px 89.03px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Body--inject-57",
    className: "animable",
    style: {
      transformOrigin: "337.115px 89.03px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,34V114.2l65.93,38.07V72.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "329.965px 93.135px"
    },
    id: "eljeig93vbcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.89 72.11 362.89 152.27 377.19 144.02 377.19 63.86 362.89 72.11",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.04px 108.065px"
    },
    id: "el0blrc244wlsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,34l65.93,38.07,14.3-8.25L311.25,25.79Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "337.115px 48.93px"
    },
    id: "el0sqrq5eaxyd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.47,132.39l2.92,1.69V53.92l-2.92-1.69Zm5.08-72.56v73l27.18,15.69v-73ZM360,147.27l-25.74-14.86V61.08L360,75.94ZM299.13,113l27.18,15.69v-73L299.13,40Zm.72-71.74,25.73,14.85v71.33l-25.73-14.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "329.93px 94.26px"
    },
    id: "elg9bc28t194m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Handlers--inject-57",
    className: "animable",
    style: {
      transformOrigin: "330.03px 95.145px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.8 96.28 323.54 95.55 323.54 87.29 324.8 88.02 324.8 96.28",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "324.17px 91.785px"
    },
    id: "el1jq8cvybi1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.52 103 335.26 102.27 335.26 94.01 336.52 94.73 336.52 103",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "335.89px 98.505px"
    },
    id: "el174hq2p0e6n",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "433.77px 141.935px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "433.77px 141.935px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-57",
    className: "animable",
    style: {
      transformOrigin: "433.77px 141.935px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "469.31 209.81 467.16 209.96 399.31 170.75 400.38 169.97 469.31 209.81",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "434.31px 189.965px"
    },
    id: "elhs4z7fvrotn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.38 169.97 467.16 208.57 467.16 113.73 400.38 75.13 400.38 169.97",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "433.77px 141.85px"
    },
    id: "elt03b4fmp43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.16,172l72.15,41.69V112.49L397.16,70.8Zm2.15-97.47,67.85,39.21V210l-67.85-39.21Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "433.235px 142.245px"
    },
    id: "elqc4y4lxty6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.31 170.75 400.38 169.97 400.38 75.13 399.31 74.52 399.31 170.75",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.845px 122.635px"
    },
    id: "el1ejtl6ri32y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.16 70.8 398.23 70.18 470.38 111.87 469.31 112.49 397.16 70.8",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "433.77px 91.335px"
    },
    id: "el3hj6ttmodvz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.38 111.87 469.31 112.49 469.31 213.68 470.38 213.06 470.38 111.87",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "469.845px 162.775px"
    },
    id: "elfod9g9s9s3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.16 161.04 400.38 122.42 399.31 123.06 467.16 162.27 467.16 161.04",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "433.235px 142.345px"
    },
    id: "elhx9smapz02",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.31 123.06 399.31 125.47 467.16 164.67 467.16 162.27 399.31 123.06",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "433.235px 143.865px"
    },
    id: "els3mqp6gmn4q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blinds--inject-57",
    className: "animable",
    style: {
      transformOrigin: "433.49px 115.695px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.38,105l-.56,2.51,67.34,38.94V143.6Zm0-4-.56,2.51,67.34,38.94v-2.86Zm0,8-.56,2.51,67.34,38.94v-2.86Zm0,4-.56,2.51,67.34,38.94v-2.86Zm-.56-33.58,67.34,38.94v-2.86L400.38,76.94Zm.56,5.51-.56,2.51,67.34,38.94v-2.86Zm0,12-.56,2.51,67.34,38.94v-2.86Zm0-8-.56,2.51,67.34,38.94v-2.86Zm0-8-.56,2.51,67.34,38.94v-2.86Zm0,12-.56,2.51,67.34,38.94v-2.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.49px 115.695px"
    },
    id: "eldms7k7i79m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2p6zetu6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.16,77.94l67,38.74v-1.15L400.38,76.94Zm.22,3-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74V143.6Zm0,4-.22,1,67,38.74v-1.15Zm0,4-.22,1,67,38.74v-1.15Z",
    style: {
      opacity: 0.2,
      transformOrigin: "433.66px 114.81px"
    },
    className: "animable",
    id: "ells62lk9b51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-57",
    className: "animable",
    style: {
      transformOrigin: "244.623px 337.604px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-57",
    d: "M452.83,327.15c9.4,5.48,9.39,14.37,0,19.85s-24.61,5.48-34,0-9.39-14.37,0-19.85S443.44,321.66,452.83,327.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.832px 337.073px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-57",
    points: "148.31 386.76 76.32 345.19 288.69 222.58 360.68 264.15 148.31 386.76",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.5px 304.67px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-57",
    d: "M30.78,402l66.7-38.51a7.58,7.58,0,0,1,6.82,0l79.18,45.72c1.87,1.08,1.88,2.86,0,3.94l-9.09,5.3,8.62,5c1.87,1.09,1.88,2.86,0,3.95l-40.94,23.83a7.51,7.51,0,0,1-6.8,0l-8.62-5-9.59,5.58a7.5,7.5,0,0,1-6.81,0L30.78,406C28.9,404.89,28.9,403.12,30.78,402Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "107.128px 407.654px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-57",
    d: "M338.66,317.65a14.53,14.53,0,0,1,13.13,0l45.42,26.22,2.89,1.67c1.59.91,1.59,2.41,0,3.33l-2.9,1.68-45.4,26.21a14.47,14.47,0,0,1-13.13,0l-45.4-26.21-2.9-1.68c-1.6-.92-1.6-2.42,0-3.33l2.89-1.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.231px 347.209px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-57",
    cx: 401.29,
    cy: 416.35,
    rx: 51.16,
    ry: 29.54,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.29px 416.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-57",
    className: "animable",
    style: {
      transformOrigin: "434.342px 287.366px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-57",
    className: "animable",
    style: {
      transformOrigin: "434.342px 287.366px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-57",
    className: "animable",
    style: {
      transformOrigin: "435.85px 320.146px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.91,337.3c-7.45-7.69-11.82-27-4.56-33.1h37c7.26,6.1,2.89,25.4-4.55,33.09l-.21.21-.25.26c-.21.2-.44.4-.68.6l-.17.14c-.19.15-.37.29-.57.43a8.25,8.25,0,0,1-1,.62c-6.13,3.58-16.06,3.58-22.18,0h0a9.3,9.3,0,0,1-1-.62c-.19-.13-.35-.27-.53-.4l-.21-.18a7.42,7.42,0,0,1-.65-.58l-.3-.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "435.85px 323.217px"
    },
    id: "elabehxoofzjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.1,301.75c8.43,4.92,8.43,12.9,0,17.83s-22.11,4.92-30.54,0-8.43-12.91,0-17.83S442.67,296.82,451.1,301.75Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "435.83px 310.665px"
    },
    id: "elfml4zoqkfwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,304.12c6.19,3.61,6.19,9.47,0,13.09s-16.23,3.61-22.42,0-6.2-9.48,0-13.09S440.85,300.5,447,304.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "435.788px 310.665px"
    },
    id: "elr8wcdz1ufj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.62,310.33c6.19-3.62,16.23-3.62,22.42,0a10.22,10.22,0,0,1,3.71,3.44,10.39,10.39,0,0,1-3.71,3.44c-6.19,3.61-16.23,3.61-22.42,0a10.39,10.39,0,0,1-3.71-3.44A10.22,10.22,0,0,1,424.62,310.33Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "435.83px 313.766px"
    },
    id: "elpq2g2tw7zm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M433.34,261.05c-2.83,3.06-10.7,3.91-14-4.38-3.06-7.78-6.35-15.15-7.3-18a2.93,2.93,0,0,1,1.89-3.79s.22-4.27,7.46-1.38,12.35,7.29,15.51,14.4S438.19,260.09,433.34,261.05Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "425.163px 247.859px"
    },
    id: "eltut103c2v2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxun08el5eln"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.34,261.05c-2.83,3.06-10.7,3.91-14-4.38-3.06-7.78-6.35-15.15-7.3-18a2.93,2.93,0,0,1,1.89-3.79s.22-4.27,7.46-1.38,12.35,7.29,15.51,14.4S438.19,260.09,433.34,261.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "425.163px 247.859px"
    },
    className: "animable",
    id: "el5i5l3sbr1ty"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.48,272a39.62,39.62,0,0,0-.63-4.33,59.23,59.23,0,0,0-2.4-8.34,61.48,61.48,0,0,0-8.39-15.49,53.3,53.3,0,0,0-6.6-7.48c-.07-.07-.13.1-.08.15A64,64,0,0,1,434.68,267c.36,1.58.7,3.16,1,4.75s.46,3.25.73,4.87c0,.16.28.26.29,0A29.67,29.67,0,0,0,436.48,272Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "427.538px 256.562px"
    },
    id: "elt7dvmglqr3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1qnh7xzlquz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.48,272a39.62,39.62,0,0,0-.63-4.33,59.23,59.23,0,0,0-2.4-8.34,61.48,61.48,0,0,0-8.39-15.49,53.3,53.3,0,0,0-6.6-7.48c-.07-.07-.13.1-.08.15A64,64,0,0,1,434.68,267c.36,1.58.7,3.16,1,4.75s.46,3.25.73,4.87c0,.16.28.26.29,0A29.67,29.67,0,0,0,436.48,272Z",
    style: {
      opacity: 0.3,
      transformOrigin: "427.538px 256.562px"
    },
    className: "animable",
    id: "ele5j1yoeehgm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.9,258.9c-6.51,2-11.34-3.07-9.66-11s10-16.8,13.19-14.42c2-2,6.32-1.27,8.36,5.2S451,261.72,438.9,258.9Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "440.205px 245.917px"
    },
    id: "el15xi1sziq36",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el06u4liweznn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.9,258.9c-6.51,2-11.34-3.07-9.66-11s10-16.8,13.19-14.42c2-2,6.32-1.27,8.36,5.2S451,261.72,438.9,258.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "440.205px 245.917px"
    },
    className: "animable",
    id: "elv6pq0zg4nfd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.71,238.29a87.91,87.91,0,0,0-4.32,14.3,138.09,138.09,0,0,0-2.51,15,233.78,233.78,0,0,0-1.31,29.35c0,2.71.06,5.41.11,8.12s0,5.61.25,8.38c.09,1.07,1.61.78,1.62-.19.1-4.88-.17-9.77-.22-14.65s0-9.64.09-14.46a202.59,202.59,0,0,1,2.64-29.31c.46-2.7,1-5.4,1.6-8.06.67-2.81,1.48-5.57,2.21-8.35C442.9,238.29,442.78,238.14,442.71,238.29Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "438.703px 276.174px"
    },
    id: "elm5psk6vexlh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgeeqedqhozj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.71,238.29a87.91,87.91,0,0,0-4.32,14.3,138.09,138.09,0,0,0-2.51,15,233.78,233.78,0,0,0-1.31,29.35c0,2.71.06,5.41.11,8.12s0,5.61.25,8.38c.09,1.07,1.61.78,1.62-.19.1-4.88-.17-9.77-.22-14.65s0-9.64.09-14.46a202.59,202.59,0,0,1,2.64-29.31c.46-2.7,1-5.4,1.6-8.06.67-2.81,1.48-5.57,2.21-8.35C442.9,238.29,442.78,238.14,442.71,238.29Z",
    style: {
      opacity: 0.3,
      transformOrigin: "438.703px 276.174px"
    },
    className: "animable",
    id: "elai4rimdlogv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,282.24c-2.84,3.21-9.35,2.93-13.72-2.81s-7-27.32-.84-25.94c1.3-2.89,18.28,4,20.46,18.12C435.8,281.84,428.31,282.24,428.31,282.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "422.275px 268.567px"
    },
    id: "elrl52xrhvfrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbvlq7vtmm8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.31,282.24c-2.84,3.21-9.35,2.93-13.72-2.81s-7-27.32-.84-25.94c1.3-2.89,18.28,4,20.46,18.12C435.8,281.84,428.31,282.24,428.31,282.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "422.275px 268.567px"
    },
    className: "animable",
    id: "elzwvrq2sv6yl"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,292.44a31,31,0,0,0-.83-3.94c-.72-2.64-1.56-5.25-2.53-7.81a82.83,82.83,0,0,0-7.59-14.89,74.63,74.63,0,0,0-5.38-7.61c-.06-.06-.11.09-.08.13,1.52,2.21,3.06,4.4,4.42,6.71s2.68,4.88,3.85,7.4a102.06,102.06,0,0,1,5.6,15c.42,1.46.76,2.94,1.19,4.4s1,3,1.39,4.53c.06.22.34.3.32,0C433.61,295.08,433.57,293.75,433.39,292.44Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "425.361px 277.366px"
    },
    id: "el28k3a1c45be",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmmb7p5b0vta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.39,292.44a31,31,0,0,0-.83-3.94c-.72-2.64-1.56-5.25-2.53-7.81a82.83,82.83,0,0,0-7.59-14.89,74.63,74.63,0,0,0-5.38-7.61c-.06-.06-.11.09-.08.13,1.52,2.21,3.06,4.4,4.42,6.71s2.68,4.88,3.85,7.4a102.06,102.06,0,0,1,5.6,15c.42,1.46.76,2.94,1.19,4.4s1,3,1.39,4.53c.06.22.34.3.32,0C433.61,295.08,433.57,293.75,433.39,292.44Z",
    style: {
      opacity: 0.3,
      transformOrigin: "425.361px 277.366px"
    },
    className: "animable",
    id: "ely0fdmskoap"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.71,279.05c-3.71-.85-3.9-5.31.74-10.79s16.36-7.87,16.91-5.56c2.6,0,2.6,8.15-3.16,15.64S439.06,284.08,438.71,279.05Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "446.988px 272.61px"
    },
    id: "ele38o7gb1wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv3hczyw03tj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.71,279.05c-3.71-.85-3.9-5.31.74-10.79s16.36-7.87,16.91-5.56c2.6,0,2.6,8.15-3.16,15.64S439.06,284.08,438.71,279.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "446.988px 272.61px"
    },
    className: "animable",
    id: "elyz7of4ch1wf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446,271.08A29.44,29.44,0,0,0,435.23,285c-.12.32.43.78.57.44A34.22,34.22,0,0,1,446,271.16S446,271.05,446,271.08Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "440.607px 278.317px"
    },
    id: "elv3n338b3zhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el17sttxti6qr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446,271.08A29.44,29.44,0,0,0,435.23,285c-.12.32.43.78.57.44A34.22,34.22,0,0,1,446,271.16S446,271.05,446,271.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "440.607px 278.317px"
    },
    className: "animable",
    id: "elap8ld9s3ty"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443,306.24c-5.15,2.09-2.94,8.22,2.08,12.87a23,23,0,0,0,15.67,5.64c3.46-.24,4.34-.72,4.34-.72a39.25,39.25,0,0,0,0-8.52,16.46,16.46,0,0,0-12.13-13.07C444.88,300.27,443,303.18,443,306.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "452.692px 313.222px"
    },
    id: "eles1ygscp2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7wy8e2wtuxv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443,306.24c-5.15,2.09-2.94,8.22,2.08,12.87a23,23,0,0,0,15.67,5.64c3.46-.24,4.34-.72,4.34-.72a39.25,39.25,0,0,0,0-8.52,16.46,16.46,0,0,0-12.13-13.07C444.88,300.27,443,303.18,443,306.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "452.692px 313.222px"
    },
    className: "animable",
    id: "el3i9tieevmu2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.21,315.3a42,42,0,0,0-7.88-7.3c-2.94-1.93-6.84-3.57-10.36-2.37-1.36.47-3.48,1.82-3.22,3.51,0,.17.32.58.52.35a14.16,14.16,0,0,1,1.85-2.16,5.57,5.57,0,0,1,2.77-1.05,12.8,12.8,0,0,1,7.22,1.64c3.48,1.85,6.29,4.71,9.06,7.46C457.2,315.41,457.23,315.32,457.21,315.3Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "446.472px 310.304px"
    },
    id: "elowwh7aqvr4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5k3l10367pl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.21,315.3a42,42,0,0,0-7.88-7.3c-2.94-1.93-6.84-3.57-10.36-2.37-1.36.47-3.48,1.82-3.22,3.51,0,.17.32.58.52.35a14.16,14.16,0,0,1,1.85-2.16,5.57,5.57,0,0,1,2.77-1.05,12.8,12.8,0,0,1,7.22,1.64c3.48,1.85,6.29,4.71,9.06,7.46C457.2,315.41,457.23,315.32,457.21,315.3Z",
    style: {
      opacity: 0.3,
      transformOrigin: "446.472px 310.304px"
    },
    className: "animable",
    id: "elk07pj0o4gv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.36,279.88c.48-2.35-2.9-8-13.46-9s-18.46,3.4-20,5.44-2.4,4.2-.49,4.74,8.51,1.17,12.84,3.17,13.13,7.88,19.14,6.13S426.34,282.21,423.36,279.88Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "407.034px 280.708px"
    },
    id: "elzhjqifoali8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxqibitq6x4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.36,279.88c.48-2.35-2.9-8-13.46-9s-18.46,3.4-20,5.44-2.4,4.2-.49,4.74,8.51,1.17,12.84,3.17,13.13,7.88,19.14,6.13S426.34,282.21,423.36,279.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "407.034px 280.708px"
    },
    className: "animable",
    id: "elyet42tmwino"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.38,288.05c-4.45-9.19-15.93-12-25.3-11.95a37.17,37.17,0,0,0-9.15,1.19s-.05.11,0,.11a48.35,48.35,0,0,1,15.28-.16,31.77,31.77,0,0,1,14,5.38,18.91,18.91,0,0,1,5,5.61C431.3,288.45,431.47,288.24,431.38,288.05Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "414.157px 282.212px"
    },
    id: "ells13jowsw6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrm7u7qhoqei"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.38,288.05c-4.45-9.19-15.93-12-25.3-11.95a37.17,37.17,0,0,0-9.15,1.19s-.05.11,0,.11a48.35,48.35,0,0,1,15.28-.16,31.77,31.77,0,0,1,14,5.38,18.91,18.91,0,0,1,5,5.61C431.3,288.45,431.47,288.24,431.38,288.05Z",
    style: {
      opacity: 0.3,
      transformOrigin: "414.157px 282.212px"
    },
    className: "animable",
    id: "el115a72u2bcsc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448,267.56c-.14,3.69,5.06,5.84,10.08,2.65s10.3-6.3,15-7.51,6.87-5,5.4-6.84-3.81-6.48-16.06-5-16.59,7-18.27,10.93S446.1,268.63,448,267.56Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "461.326px 261.167px"
    },
    id: "ela7xvnaqt5ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elou4zmuuvcas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,267.56c-.14,3.69,5.06,5.84,10.08,2.65s10.3-6.3,15-7.51,6.87-5,5.4-6.84-3.81-6.48-16.06-5-16.59,7-18.27,10.93S446.1,268.63,448,267.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "461.326px 261.167px"
    },
    className: "animable",
    id: "elq1c3e04772"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.88,255.84a13.35,13.35,0,0,0-5.25.55,26.5,26.5,0,0,0-4.5,1.61,25.16,25.16,0,0,0-7.66,5.55,23,23,0,0,0-1.73,2.08,8.88,8.88,0,0,0-1.3,2.14c-.09.25.27.64.48.4.61-.7,1.06-1.56,1.63-2.29a23.62,23.62,0,0,1,2-2.26,25.28,25.28,0,0,1,4.72-3.72,29.36,29.36,0,0,1,5.23-2.54,29.7,29.7,0,0,1,3-.92,10.76,10.76,0,0,1,3.33-.46C467.91,256,467.94,255.85,467.88,255.84Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "457.669px 262.013px"
    },
    id: "elk4t5rnvlpxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el03d8ddt8yq8g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.88,255.84a13.35,13.35,0,0,0-5.25.55,26.5,26.5,0,0,0-4.5,1.61,25.16,25.16,0,0,0-7.66,5.55,23,23,0,0,0-1.73,2.08,8.88,8.88,0,0,0-1.3,2.14c-.09.25.27.64.48.4.61-.7,1.06-1.56,1.63-2.29a23.62,23.62,0,0,1,2-2.26,25.28,25.28,0,0,1,4.72-3.72,29.36,29.36,0,0,1,5.23-2.54,29.7,29.7,0,0,1,3-.92,10.76,10.76,0,0,1,3.33-.46C467.91,256,467.94,255.85,467.88,255.84Z",
    style: {
      opacity: 0.3,
      transformOrigin: "457.669px 262.013px"
    },
    className: "animable",
    id: "el0crw7yezyih"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.16,287.49c-1.72-1.72-6.38-1.32-8.58,3.75s2.42,10.62,2.94,12.18c2.13-1.23,3.78-.49,7.53-1.23a9.35,9.35,0,0,0,7.18-9.32C448,288.22,446,285.16,439.16,287.49Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "439.111px 294.995px"
    },
    id: "el61o53rjbmc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleswj0gfgsq5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.16,287.49c-1.72-1.72-6.38-1.32-8.58,3.75s2.42,10.62,2.94,12.18c2.13-1.23,3.78-.49,7.53-1.23a9.35,9.35,0,0,0,7.18-9.32C448,288.22,446,285.16,439.16,287.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "439.111px 294.995px"
    },
    className: "animable",
    id: "elasfozb8fuy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.09,287a7,7,0,0,0-2.27,2.35,12.76,12.76,0,0,0-1.47,2.84,12,12,0,0,0-.65,6.46c0,.08.08,0,.08,0a12.67,12.67,0,0,1,2.63-8.95,13,13,0,0,1,1-1.2,6.56,6.56,0,0,0,1-1C439.55,287.27,439.35,286.85,439.09,287Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "436.988px 292.827px"
    },
    id: "el367m7nw3e0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhrce5cw6uqp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.09,287a7,7,0,0,0-2.27,2.35,12.76,12.76,0,0,0-1.47,2.84,12,12,0,0,0-.65,6.46c0,.08.08,0,.08,0a12.67,12.67,0,0,1,2.63-8.95,13,13,0,0,1,1-1.2,6.56,6.56,0,0,0,1-1C439.55,287.27,439.35,286.85,439.09,287Z",
    style: {
      opacity: 0.3,
      transformOrigin: "436.988px 292.827px"
    },
    className: "animable",
    id: "el6wcawo6zy8v"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,297.76c-.16-3.77-4.25-6.76-10.07-8.49a15.83,15.83,0,0,0-16.36,4.35c-4.25,4.62-6.45,8.55-4.72,9.65s9.44,3.93,14.47,5.51,11.65,2,16.68-.95S435.8,299.65,431.08,297.76Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "417.037px 299.276px"
    },
    id: "elz7h2m8fkc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elas4aojr5be5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.08,297.76c-.16-3.77-4.25-6.76-10.07-8.49a15.83,15.83,0,0,0-16.36,4.35c-4.25,4.62-6.45,8.55-4.72,9.65s9.44,3.93,14.47,5.51,11.65,2,16.68-.95S435.8,299.65,431.08,297.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "417.037px 299.276px"
    },
    className: "animable",
    id: "elx7n8mf4sgzl"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.4,297.34a16.06,16.06,0,0,0-6.32-1.69,29.21,29.21,0,0,0-6.34.08,39.86,39.86,0,0,0-6.56,1.38q-1.68.5-3.33,1.11a22.32,22.32,0,0,0-3,1.25s-.06.14,0,.13c1.07-.22,2.11-.64,3.16-1s2.25-.68,3.39-1a43,43,0,0,1,6.46-1.22,28.87,28.87,0,0,1,6.57,0,39.24,39.24,0,0,1,6,1.45C431.75,298,431.63,297.47,431.4,297.34Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "418.724px 297.558px"
    },
    id: "elfok6lr2d9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8cvb7immidn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.4,297.34a16.06,16.06,0,0,0-6.32-1.69,29.21,29.21,0,0,0-6.34.08,39.86,39.86,0,0,0-6.56,1.38q-1.68.5-3.33,1.11a22.32,22.32,0,0,0-3,1.25s-.06.14,0,.13c1.07-.22,2.11-.64,3.16-1s2.25-.68,3.39-1a43,43,0,0,1,6.46-1.22,28.87,28.87,0,0,1,6.57,0,39.24,39.24,0,0,1,6,1.45C431.75,298,431.63,297.47,431.4,297.34Z",
    style: {
      opacity: 0.3,
      transformOrigin: "418.724px 297.558px"
    },
    className: "animable",
    id: "elsormn01nz"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.09,292.14c-4.16-3.3-2.77-11.23,11.79-11.66s25,3.38,24.5,8.06c2.35,2.35,1.16,8.91-10.63,11S440.09,300.53,443.09,292.14Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "460.71px 290.451px"
    },
    id: "elsabsub6a48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrdac9dlgbu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.09,292.14c-4.16-3.3-2.77-11.23,11.79-11.66s25,3.38,24.5,8.06c2.35,2.35,1.16,8.91-10.63,11S440.09,300.53,443.09,292.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "460.71px 290.451px"
    },
    className: "animable",
    id: "elv3e2n5q96li"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.53,288.59a62.21,62.21,0,0,0-13-.75,50,50,0,0,0-12,1.38,18.42,18.42,0,0,0-2.93,1.08c-.43.21-.86.44-1.27.69s-.7.37-.82.76a.39.39,0,0,0,.43.46,15.48,15.48,0,0,0,2.55-1.26A21.62,21.62,0,0,1,448,290a31,31,0,0,1,5.06-1,88.5,88.5,0,0,1,12.29-.68c2.39,0,4.78.21,7.16.4C472.58,288.77,472.6,288.61,472.53,288.59Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "457.538px 289.992px"
    },
    id: "elaz990gibzzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3v4vwaz99df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.53,288.59a62.21,62.21,0,0,0-13-.75,50,50,0,0,0-12,1.38,18.42,18.42,0,0,0-2.93,1.08c-.43.21-.86.44-1.27.69s-.7.37-.82.76a.39.39,0,0,0,.43.46,15.48,15.48,0,0,0,2.55-1.26A21.62,21.62,0,0,1,448,290a31,31,0,0,1,5.06-1,88.5,88.5,0,0,1,12.29-.68c2.39,0,4.78.21,7.16.4C472.58,288.77,472.6,288.61,472.53,288.59Z",
    style: {
      opacity: 0.3,
      transformOrigin: "457.538px 289.992px"
    },
    className: "animable",
    id: "elo05jpdy35ph"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-57",
    className: "animable",
    style: {
      transformOrigin: "245.254px 251.116px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--massage-table--inject-57",
    className: "animable",
    style: {
      transformOrigin: "222.99px 259.629px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-57",
    className: "animable",
    style: {
      transformOrigin: "222.99px 259.629px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,328.76V253.94h5.34v74.82h0a1.34,1.34,0,0,1-.78,1.1,4.19,4.19,0,0,1-3.78,0A1.34,1.34,0,0,1,110,328.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.67px 292.125px"
    },
    id: "el467bevigkqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.14 321.58 101.33 280.13 101.33 258.31 173.13 299.76 173.14 321.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.235px 289.945px"
    },
    id: "el5i77ca9t8is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46,363.67V288.85h5.35v74.82h0a1.31,1.31,0,0,1-.79,1.09,4.11,4.11,0,0,1-3.77,0A1.31,1.31,0,0,1,170.46,363.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "173.135px 327.034px"
    },
    id: "eltg8o62ce4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.27,288.12V213.3h5.35v74.82h0a1.33,1.33,0,0,1-.79,1.09,4.13,4.13,0,0,1-3.78,0A1.32,1.32,0,0,1,180.27,288.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "182.945px 251.484px"
    },
    id: "el5m5g1y1rktb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.41 280.94 171.61 239.48 171.61 217.66 243.41 259.12 243.41 280.94",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.51px 249.3px"
    },
    id: "elmxteldvbl4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,323V248.21h5.34V323h0a1.32,1.32,0,0,1-.78,1.09,4.19,4.19,0,0,1-3.78,0A1.32,1.32,0,0,1,240.74,323Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "243.41px 286.375px"
    },
    id: "el1du03cahsg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.64 263.48 201.84 222.03 201.84 200.21 273.64 241.66 273.64 263.48",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.74px 231.845px"
    },
    id: "el2z72fwm813q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,270.67V195.85h5.35v74.82h0a1.33,1.33,0,0,1-.78,1.09,4.19,4.19,0,0,1-3.78,0A1.32,1.32,0,0,1,210.5,270.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "213.175px 234.03px"
    },
    id: "el8ooxwbqvjwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,305.58V230.76h5.34v74.82h0a1.33,1.33,0,0,1-.78,1.09,4.19,4.19,0,0,1-3.78,0A1.33,1.33,0,0,1,271,305.58Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "273.67px 268.94px"
    },
    id: "el6hafm0wysis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,234.05V159.22h5.34v74.83h0a1.33,1.33,0,0,1-.78,1.09,4.19,4.19,0,0,1-3.78,0A1.33,1.33,0,0,1,273.94,234.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "276.61px 197.405px"
    },
    id: "eltefvwlyya6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.07 226.86 265.27 185.41 265.27 163.59 337.07 205.04 337.07 226.86",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.17px 195.225px"
    },
    id: "eltwxf7lgdwgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,269V194.13h5.35V269h0a1.34,1.34,0,0,1-.79,1.09,4.19,4.19,0,0,1-3.78,0A1.34,1.34,0,0,1,334.4,269Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "337.075px 232.335px"
    },
    id: "ely0xhpffvhpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,189.63,288.2,155a8.94,8.94,0,0,0-8.06,0l-81.83,47.25c-2.22,1.28-4,3.3-4,4.5v2.19l68,39.27,89.89-51.89v-2.19C352.19,192.93,350.39,190.91,348.16,189.63Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "273.255px 201.125px"
    },
    id: "el568vn5kotg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elml3vmuepv28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.16,189.63,288.2,155a8.94,8.94,0,0,0-8.06,0l-81.83,47.25c-2.22,1.28-4,3.3-4,4.5v2.19l68,39.27,89.89-51.89v-2.19C352.19,192.93,350.39,190.91,348.16,189.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "273.255px 201.125px"
    },
    className: "animable",
    id: "elz3cakmu7d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqn9immpv8vh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.28,241.52l-60-34.62c-2.22-1.29-2.22-3.37,0-4.65L280.14,155a8.94,8.94,0,0,1,8.06,0l60,34.63c2.23,1.28,2.23,3.36,0,4.65l-81.83,47.24A8.92,8.92,0,0,1,258.28,241.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "273.244px 198.265px"
    },
    className: "animable",
    id: "elpxenkkof3ll"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "352.19 196.31 352.19 200.68 262.3 252.57 262.3 248.21 352.19 196.31",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "307.245px 224.44px"
    },
    id: "eluq609rmehf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.28 208.94 194.28 213.3 262.3 252.57 262.3 248.21 194.28 208.94",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "228.29px 230.755px"
    },
    id: "elqw321obm03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,243.7l-60-34.62a8.94,8.94,0,0,0-8.06,0L97.8,260.34c-2.22,1.29-4,3.31-4,4.51V267l68,39.28,96.73-55.92v-2.18C258.53,247,256.72,245,254.5,243.7Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "176.165px 257.2px"
    },
    id: "elrqunkppf2wn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxnacaf93yb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.5,243.7l-60-34.62a8.94,8.94,0,0,0-8.06,0L97.8,260.34c-2.22,1.29-4,3.31-4,4.51V267l68,39.28,96.73-55.92v-2.18C258.53,247,256.72,245,254.5,243.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "176.165px 257.2px"
    },
    className: "animable",
    id: "elv5534ju3ya"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elopxzren2gen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.77,299.62,97.8,265c-2.22-1.29-2.22-3.37,0-4.66l88.67-51.26a8.94,8.94,0,0,1,8.06,0l60,34.62c2.22,1.29,2.22,3.37,0,4.65l-88.67,51.27A8.94,8.94,0,0,1,157.77,299.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "176.165px 254.354px"
    },
    className: "animable",
    id: "elnkntv5ih76h"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "258.52 250.39 258.52 254.75 161.8 310.67 161.8 306.31 258.52 250.39",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "210.16px 280.53px"
    },
    id: "eld29cm40ewdw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.78 267.03 93.78 271.4 161.8 310.67 161.8 306.31 93.78 267.03",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.79px 288.85px"
    },
    id: "el4getnvj5ghd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,331.24a.94.94,0,0,0,.6-.23L244,268.55a.93.93,0,1,0-1.2-1.41L172.53,329.6a.92.92,0,0,0-.1,1.31A.91.91,0,0,0,173.14,331.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "208.3px 299.049px"
    },
    id: "elfna0zt24i5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,309.42a.75.75,0,0,0,.26,0l70.28-18.82a.93.93,0,0,0-.54-1.79L172.87,307.6a.93.93,0,0,0,.27,1.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "208.277px 299.101px"
    },
    id: "elnl8o4lb2kon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,273.14a.89.89,0,0,0,.6-.22l63.44-58.44a.93.93,0,0,0-1.21-1.42L273,271.5a.93.93,0,0,0,.6,1.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.338px 242.989px"
    },
    id: "elug3almd5ofm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,251.32a.84.84,0,0,0,.27,0l63.43-14.8a.93.93,0,1,0-.54-1.78l-63.43,14.8a.93.93,0,0,0,.27,1.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.355px 243.03px"
    },
    id: "elgqa7kz5qpzd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pillow--inject-57",
    className: "animable",
    style: {
      transformOrigin: "296.685px 183.981px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.21,180.12c0-1.71,2.55-4.58,5.71-6.4l12.69-7.33A8.62,8.62,0,0,1,289,165h0c2.74,0,13.65,5.27,19,8.37S325.08,183.88,326.9,187c.6,1-20.5,16.35-23.08,15.81-5.74-1.2-16.12-6.15-21.45-9.39-8.69-5.31-13.62-9.72-15.35-11.61A2.22,2.22,0,0,1,266.21,180.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.561px 183.912px"
    },
    id: "el2r64iamivgv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.44,194.2l-12.69,7.33c-3.16,1.82-5.72,1.92-5.72.21s2.56-4.58,5.72-6.4L321.44,188c3.16-1.82,5.72-1.91,5.72-.2S324.6,192.38,321.44,194.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "315.095px 194.768px"
    },
    id: "elx10mj6f8os",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-57",
    className: "animable",
    style: {
      transformOrigin: "265.758px 251.116px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-57",
    className: "animable",
    style: {
      transformOrigin: "322.577px 269.828px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-57",
    className: "animable",
    style: {
      transformOrigin: "343.299px 275.786px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.74,355a4.65,4.65,0,0,1-.11,1,2.39,2.39,0,0,1-.93,1.43l0,0a2.7,2.7,0,0,1-2.85-.22,8.64,8.64,0,0,1-3.92-6.78A2.77,2.77,0,0,1,359,348h0l.18-.11h0a2.44,2.44,0,0,1,1.66-.07,4.92,4.92,0,0,1,1,.42A8.65,8.65,0,0,1,365.74,355Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "361.83px 352.722px"
    },
    id: "elabkoa0plbai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,346.61a3.61,3.61,0,0,0-1.74-.53,2.08,2.08,0,0,0-1.11.31l-.1.05-2.52,1.46a2.44,2.44,0,0,1,1.66-.07,4.92,4.92,0,0,1,1,.42,8.65,8.65,0,0,1,3.92,6.78,4.65,4.65,0,0,1-.11,1,2.39,2.39,0,0,1-.93,1.43l2.6-1.5,0,0,.22-.13.07,0a2.9,2.9,0,0,0,1-2.4A8.66,8.66,0,0,0,364.67,346.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.919px 351.77px"
    },
    id: "elg0v5s9gj2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.36,332.24a5.42,5.42,0,0,1-.11,1,2.39,2.39,0,0,1-.93,1.43l0,0a2.68,2.68,0,0,1-2.84-.22,8.64,8.64,0,0,1-3.92-6.79,2.78,2.78,0,0,1,1.1-2.48h0l.19-.11h0a2.48,2.48,0,0,1,1.67-.07,4.39,4.39,0,0,1,1,.42A8.66,8.66,0,0,1,323.36,332.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "319.454px 329.932px"
    },
    id: "elt2c01pn0f7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28,323.82a3.48,3.48,0,0,0-1.74-.53,2,2,0,0,0-1.1.31l-.1,0-2.53,1.46a2.48,2.48,0,0,1,1.67-.07,4.39,4.39,0,0,1,1,.42,8.66,8.66,0,0,1,3.92,6.78,5.42,5.42,0,0,1-.11,1,2.39,2.39,0,0,1-.93,1.43l2.59-1.5,0,0,.22-.14.06,0a2.88,2.88,0,0,0,1-2.41A8.63,8.63,0,0,0,322.28,323.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.524px 328.955px"
    },
    id: "elbk8e06lx018",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,363.93a4.72,4.72,0,0,0,.11,1,2.34,2.34,0,0,0,.92,1.43l0,0a2.68,2.68,0,0,0,2.84-.22,8.64,8.64,0,0,0,3.92-6.79,2.78,2.78,0,0,0-1.1-2.48h0l-.19-.11h0a2.47,2.47,0,0,0-1.67-.07,4.6,4.6,0,0,0-1,.42A8.67,8.67,0,0,0,330.92,363.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "334.821px 361.622px"
    },
    id: "el99bcl7o2kl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,355.51a3.48,3.48,0,0,1,1.74-.53,2,2,0,0,1,1.1.31l.1,0,2.53,1.46a2.47,2.47,0,0,0-1.67-.07,4.6,4.6,0,0,0-1,.42,8.67,8.67,0,0,0-3.91,6.78,4.72,4.72,0,0,0,.11,1,2.34,2.34,0,0,0,.92,1.43l-2.59-1.5,0,0-.23-.14-.06,0a2.88,2.88,0,0,1-1-2.41A8.63,8.63,0,0,1,332,355.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.751px 360.645px"
    },
    id: "el2ke8ghzaoiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.4,350.45a5.33,5.33,0,0,0,.11,1,2.36,2.36,0,0,0,.93,1.43l0,0a2.72,2.72,0,0,0,2.85-.23,8.64,8.64,0,0,0,3.92-6.78,2.79,2.79,0,0,0-1.1-2.49h0l-.19-.11h0a2.42,2.42,0,0,0-1.67-.06,4.39,4.39,0,0,0-1,.42A8.64,8.64,0,0,0,303.4,350.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "307.311px 348.134px"
    },
    id: "elhc11sjs8w7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.47,342a3.65,3.65,0,0,1,1.75-.53,2,2,0,0,1,1.1.31l.1.06,2.53,1.45a2.42,2.42,0,0,0-1.67-.06,4.39,4.39,0,0,0-1,.42,8.64,8.64,0,0,0-3.92,6.77,5.33,5.33,0,0,0,.11,1,2.36,2.36,0,0,0,.93,1.43l-2.59-1.5-.05,0-.22-.13a.13.13,0,0,1-.06-.05,2.87,2.87,0,0,1-1-2.4A8.65,8.65,0,0,1,304.47,342Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.211px 347.16px"
    },
    id: "elvx0sv8p8wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.59,333.92a4.65,4.65,0,0,0,.11,1,2.36,2.36,0,0,0,.92,1.44l0,0a2.7,2.7,0,0,0,2.84-.22,8.65,8.65,0,0,0,3.92-6.79,2.77,2.77,0,0,0-1.1-2.48v0l-.19-.11h0a2.42,2.42,0,0,0-1.67-.06,4.39,4.39,0,0,0-1,.42A8.63,8.63,0,0,0,356.59,333.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "360.491px 331.621px"
    },
    id: "elgyg5aafbmcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.66,325.5a3.58,3.58,0,0,1,1.74-.53,2,2,0,0,1,1.1.31l.1.06,2.53,1.45a2.42,2.42,0,0,0-1.67-.06,4.39,4.39,0,0,0-1,.42,8.63,8.63,0,0,0-3.91,6.77,4.65,4.65,0,0,0,.11,1,2.36,2.36,0,0,0,.92,1.44L355,334.88l0,0-.23-.13-.06,0a2.9,2.9,0,0,1-1-2.41A8.63,8.63,0,0,1,357.66,325.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.416px 330.665px"
    },
    id: "elhdt0qgqog5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.2 325.64 319.21 321.63 319.21 324.62 333.2 332.69 333.2 325.64",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.205px 327.16px"
    },
    id: "elqj3d1br06uk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.2 325.64 334.58 324.8 320.55 320.96 319.21 321.63 333.2 325.64",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "326.895px 323.3px"
    },
    id: "el0mrhfct6874",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.25 334.56 359.08 327.13 359.08 324.1 339.25 325.88 339.25 334.56",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "349.165px 329.33px"
    },
    id: "el4mqzv11su6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.08 324.1 357.62 323.72 338.07 324.98 339.25 325.88 359.08 324.1",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "348.575px 324.8px"
    },
    id: "ely1gs2dvpii8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.78,333.6c0,2.25-6.9,2.25-6.9,0v-26h6.9Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "336.33px 321.444px"
    },
    id: "elkqvml1qbigm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.61,328.5l-3.79,24.63h2.59L337,328.5A4.25,4.25,0,0,1,334.61,328.5Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "333.91px 340.815px"
    },
    id: "el84a6b1hjkxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.96 328.5 336.96 335.26 333.41 357.29 333.41 353.13 336.96 328.5",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "335.185px 342.895px"
    },
    id: "el3v5hcaczbg3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 353.13,
    width: 2.59,
    height: 4.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "332.115px 355.215px"
    },
    id: "eld4fe9dqmbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.14 335.06 363.71 348.47 363.71 344.34 338.14 328.52 338.14 335.06",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "350.925px 338.495px"
    },
    id: "elb05lofc0u0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,328.52a2.87,2.87,0,0,0,1.64-.74l25.53,15.48-1.6,1.08Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "351.725px 336.06px"
    },
    id: "elfv8k9t8hu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.71 348.47 363.71 344.34 365.31 343.26 365.31 347.26 363.71 348.47",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "364.51px 345.865px"
    },
    id: "elnn3izp8qu7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.9 343.73 333.22 334.38 333.22 328.24 305.9 339.61 305.9 343.73",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "319.56px 335.985px"
    },
    id: "elrsrmh10nahg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,328.24c-.22-.06-.32-.46-.34-1.06l-27.79,12.09.81.34Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "319.155px 333.395px"
    },
    id: "ell2gt2ebzyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.09 339.27 305.09 343.27 305.9 343.73 305.9 339.61 305.09 339.27",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.495px 341.5px"
    },
    id: "eleq6xubhgzrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elluh1w2ezkm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 353.13,
    width: 2.59,
    height: 4.17,
    style: {
      opacity: 0.1,
      transformOrigin: "332.115px 355.215px"
    },
    className: "animable",
    id: "elz6zlakoik0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5c9k7gpvrit"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "363.71 348.47 363.71 344.34 365.31 343.26 365.31 347.26 363.71 348.47",
    style: {
      opacity: 0.1,
      transformOrigin: "364.51px 345.865px"
    },
    className: "animable",
    id: "elfcop4rdn5wb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elephxcl0s9ow"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "305.09 339.27 305.09 343.27 305.9 343.73 305.9 339.61 305.09 339.27",
    style: {
      opacity: 0.1,
      transformOrigin: "305.495px 341.5px"
    },
    className: "animable",
    id: "el05tchvd9zsd7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,289.75h9.66v28.16c0,2.78-9.66,2.78-9.66,0Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "336.33px 304.872px"
    },
    id: "elqdi9443hgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,286v2.61l42.44,24.5a5.43,5.43,0,0,0,5.43,0l42.45-24.5V286Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "337.45px 299.919px"
    },
    id: "el1b30zt6mnot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.3,
    y: 250.39,
    width: 4.52,
    height: 22.42,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "313.56px 261.6px"
    },
    id: "elzfmna3gu9qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.53,245.34,289.87,259l9,5.22L326,248.57l-5.6-3.23A6.84,6.84,0,0,0,313.53,245.34Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "307.935px 254.317px"
    },
    id: "elcbnamc6tkx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltel9o4f7k2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.53,245.34,289.87,259l9,5.22L326,248.57l-5.6-3.23A6.84,6.84,0,0,0,313.53,245.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "307.935px 254.317px"
    },
    className: "animable",
    id: "elnlm7v9zkd2c"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "325.99 251 325.99 248.57 298.9 264.22 298.9 266.64 325.99 251",
    style: {
      fill: "#3293C4",
      transformOrigin: "312.445px 257.605px"
    },
    id: "ellr5vzso2su",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el699kcwhwxm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "325.99 251 325.99 248.57 298.9 264.22 298.9 266.64 325.99 251",
    style: {
      opacity: 0.3,
      transformOrigin: "312.445px 257.605px"
    },
    className: "animable",
    id: "el47og9cumkf9"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "289.87 259 289.87 261.43 298.9 266.64 298.9 264.22 289.87 259",
    style: {
      fill: "#3293C4",
      transformOrigin: "294.385px 262.82px"
    },
    id: "elu2uzq4wcap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elugc5kniifs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "289.87 259 289.87 261.43 298.9 266.64 298.9 264.22 289.87 259",
    style: {
      opacity: 0.15,
      transformOrigin: "294.385px 262.82px"
    },
    className: "animable",
    id: "el1bwkkaqjlco"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.85,272.9a3.67,3.67,0,0,1-1.91-3.71l2.11-14.7c.15-1.07,1.1-1.48,2.12-.92l7.64,4.26a3.2,3.2,0,0,1,1.57,3l-2.14,14.93a3.64,3.64,0,0,0,1.94,3.72l-4.55-2.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.649px 266.4px"
    },
    id: "elr8li4kkz48j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,273.33a3.64,3.64,0,0,1-1.91-3.71l2.1-14.7a1.31,1.31,0,0,1,2.13-.91l7.64,4.25a3.18,3.18,0,0,1,1.56,3L364,276.16a3.61,3.61,0,0,0,1.94,3.72l-4.55-2.63Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "359.394px 266.799px"
    },
    id: "elfkm75ur85z7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.6,286l-42.39,24.48a5.51,5.51,0,0,1-5.51,0L292.29,286a9,9,0,0,1,4.51-7.82l3.82-2.19c.23-.15.46-.27.71-.42l31-17.9a10.11,10.11,0,0,1,10.2,0l35.53,20.51.09.07.08.06A9,9,0,0,1,382.6,286Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "337.445px 283.754px"
    },
    id: "els8kamd0yz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc8nvbgl9wlh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.29,286a9,9,0,0,1,4.51-7.82l3.82-2.19c-5.33,3.14-7.52,5.25-3.8,7.4l37.79,21.82a5.65,5.65,0,0,0,2.84.76v5.22a5.65,5.65,0,0,1-2.84-.76Z",
    style: {
      opacity: 0.15,
      transformOrigin: "314.87px 293.59px"
    },
    className: "animable",
    id: "el3iqogz961qo"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elw7udt7bifa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.3,305.21c7.13-4.13,25.75-14.9,33.29-19.21,7.87-4.51,5.41-7.12,4.67-7.69A9,9,0,0,1,382.6,286l-42.29,24.43a5.65,5.65,0,0,1-2.86.76V306A5.69,5.69,0,0,0,340.3,305.21Z",
    style: {
      opacity: 0.3,
      transformOrigin: "360.025px 294.75px"
    },
    className: "animable",
    id: "elubtoi8zrva"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.31,186.75c.54-.22,2.7-1.16,3.26-1.39,1.9-.8,4.33-.57,6.84.88l22.47,12.95c5.05,2.9,8.51,9.61,7.74,15l-7.69,53.72-3.27,1.4-40.73-23.51,7.69-53.69A6.41,6.41,0,0,1,356.31,186.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "370.829px 227.107px"
    },
    id: "elctdqjcfzzi7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.77,226l4.85-33.87a6.41,6.41,0,0,1,3.69-5.35c.54-.22,2.7-1.16,3.26-1.39,1.9-.8,4.33-.57,6.84.88l22.47,12.95a16.16,16.16,0,0,1,6.13,6.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "371.39px 205.467px"
    },
    id: "el805qps9p8op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.31,186.76c1.9-.8,4.32-.57,6.83.87l22.47,13c5,2.9,8.51,9.61,7.74,15l-7.69,53.73-4.49,1.89-40.72-23.51L348.13,194a6.45,6.45,0,0,1,3.58-5.3C352.5,188.35,355.55,187.08,356.31,186.76Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "366.953px 228.777px"
    },
    id: "eljqzro0534th",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxxq2vth1g7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.74,207.31a14.36,14.36,0,0,1,1.61,8.26l-7.69,53.73-4.49,1.89-40.72-23.51,2.83-19.8Z",
    style: {
      opacity: 0.3,
      transformOrigin: "366.939px 239.25px"
    },
    className: "animable",
    id: "elnlbqd6i3e0h"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfyl73or8hte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.13,194a6.45,6.45,0,0,1,3.58-5.3c.79-.35,3.84-1.62,4.6-1.94,1.9-.8,4.32-.57,6.83.87l22.47,13a16.23,16.23,0,0,1,6.13,6.72l-48.46,20.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "367.51px 207.112px"
    },
    className: "animable",
    id: "elrzwl86ax4q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,271.19l7.7-53.72c.77-5.38-2.7-12.09-7.74-15l-22.47-12.95c-5.05-2.91-9.76-.91-10.53,4.47l-7.68,53.68Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "364.714px 229.687px"
    },
    id: "elft881mhxi6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-57",
    className: "animable",
    style: {
      transformOrigin: "308.349px 269.828px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-57",
    className: "animable",
    style: {
      transformOrigin: "307.4px 319.802px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287,341.17l1.45-14.57-18.07-1.74s.83,11.49.77,16.76c0,2.49-1.74,7.18-1.74,7.18s7.14,3.63,10.82,2.08,6.07-7.38,6-8.44Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "278.93px 338.063px"
    },
    id: "elgtl4huvtl39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86,366.63c-.25,0-.35,2.34,1.09,3.42a18,18,0,0,0,12.89,2.44c6.06-1.12,9.26-3.16,11.59-5.31s5.58-5.18,8.31-5.93a19.86,19.86,0,0,0,6.67-3.77c.77-.83.45-4.29.45-4.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.319px 362.995px"
    },
    id: "elxsk7vjhck3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.08,339.78s.33.15.54.94c.24.95.61,3.72,1.1,5.27a27.72,27.72,0,0,1,1.1,8.4c-.23,1.8-5,4.21-7.6,5.36a33.94,33.94,0,0,0-8.34,5.86c-2.73,2.49-8.63,5.25-12.61,5.45-4.71.22-10.1-1-11.44-3.06-1.66-2.58-2.94-5.61,3.86-9.18,1.28-.68,5.77-3.64,7.29-4.71,4.13-2.89,7-5.5,8.69-10.3a2.61,2.61,0,0,1,.92-1.49,2.23,2.23,0,0,1,1.35-.2c1.17.1,5.85.47,6.94.91s2.32.82,2.37,2a3.87,3.87,0,0,1-.19,1.21c-.07.25-.12.57.11.7s.47,0,.64-.21a18.9,18.9,0,0,0,1.75-2.33,20.19,20.19,0,0,1,1.68-2.11,12,12,0,0,0,1.15-.83A2.72,2.72,0,0,0,287.08,339.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "269.169px 355.433px"
    },
    id: "el00z6j8wlm5c2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,365.61c1.16-1.05,2.4-2.08,3.64-3h0s-7.92,5.37-11.37,3.32c-2.22-1.31-1.31-3.12-1.29-3.68S257.1,358.16,255,358h0c-.56.35-1,.65-1.32.79-5.33,2.45-5.89,5.26-4.78,8.68,1.34,2.09,6.2,4,12.28,3.7C265.17,371,271.15,368.1,273.88,365.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "262.974px 364.601px"
    },
    id: "elnocjrr7bm1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,360.58c-4.24,1.95-2.34,2.65-1.12,2.75s8.29-4.5,12.54-8.22c4.44-3.88,7.78-8.95,9.43-10.37.61-.53,1.27-1.18,1.85-1.79-.17-.93-.31-1.78-.42-2.23-.21-.79-.54-.94-.54-.94a5.2,5.2,0,0,1-.69,1.69,12,12,0,0,1-1.15.83,20.19,20.19,0,0,0-1.68,2.11,18.9,18.9,0,0,1-1.75,2.33C278.29,351.69,269.58,358.63,265.34,360.58Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "275.381px 351.556px"
    },
    id: "elhykr35rld3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49,362.69a.54.54,0,0,0,.27-.11.42.42,0,0,0,0-.6c-1.32-1.41-7.33-4.59-10.5-4.07a.43.43,0,1,0,.14.84c3-.49,8.68,2.68,9.72,3.8A.45.45,0,0,0,264.49,362.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.363px 360.273px"
    },
    id: "elye5zag79d2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.15,360.18a.38.38,0,0,0,.26-.11.42.42,0,0,0,0-.6c-1.31-1.41-7.32-4.59-10.5-4.07a.43.43,0,1,0,.14.84c3-.48,8.69,2.69,9.73,3.8A.41.41,0,0,0,268.15,360.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.013px 357.764px"
    },
    id: "elo9mcml64sgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.81,357.8a.57.57,0,0,0,.27-.11.43.43,0,0,0,0-.6c-1.31-1.41-7.33-4.6-10.5-4.07a.43.43,0,1,0,.14.84c3-.49,8.69,2.68,9.73,3.8A.44.44,0,0,0,271.81,357.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.681px 355.381px"
    },
    id: "elmlm7a4594f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.17,355.12a.46.46,0,0,0,.27-.11.42.42,0,0,0,0-.6c-1.32-1.41-7.34-4.59-10.5-4.07a.43.43,0,1,0,.14.84c3-.48,8.68,2.69,9.72,3.8A.42.42,0,0,0,275.17,355.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "270.043px 352.703px"
    },
    id: "eln9cxbnjmqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.47,352.44a.44.44,0,0,0,.26-.1.42.42,0,0,0,0-.6c-1.8-2-8.06-4.59-11.23-4.07a.43.43,0,0,0-.36.49.44.44,0,0,0,.5.35c2.86-.47,8.85,2,10.45,3.79A.43.43,0,0,0,278.47,352.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.996px 350.023px"
    },
    id: "el6bggpo5dsbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.55,360.4l1.21-14.59-18.09-1.43s1,11.47,1.05,16.74c0,2.49-1.63,7.21-1.63,7.21s7.21,3.5,10.86,1.9,5.94-7.48,5.83-8.54Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "313.425px 357.514px"
    },
    id: "elbp3li5vwjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,386.49c-.25,0-.31,2.35,1.14,3.4A18,18,0,0,0,298,392.12c6-1.21,9.2-3.31,11.49-5.5s5.5-5.27,8.22-6.07a19.75,19.75,0,0,0,6.6-3.88c.76-.83.39-4.29.39-4.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.271px 382.437px"
    },
    id: "el351vqficue1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.66,359s.34.15.56.94c.26.94.67,3.71,1.19,5.25a27.89,27.89,0,0,1,1.23,8.38c-.2,1.8-4.91,4.29-7.5,5.48a34.25,34.25,0,0,0-8.25,6c-2.69,2.54-8.54,5.39-12.52,5.65-4.71.31-10.12-.81-11.49-2.87-1.7-2.55-3-5.55,3.71-9.24,1.27-.7,5.71-3.73,7.21-4.83,4.08-3,6.91-5.61,8.52-10.44a2.61,2.61,0,0,1,.9-1.5,2.19,2.19,0,0,1,1.34-.22c1.18.07,5.86.37,7,.79s2.33.79,2.4,2a3.64,3.64,0,0,1-.17,1.22c-.07.24-.11.57.12.69s.47,0,.64-.22a18.2,18.2,0,0,0,1.71-2.36,20.2,20.2,0,0,1,1.64-2.14,10.82,10.82,0,0,0,1.14-.84A2.73,2.73,0,0,0,321.66,359Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "304.077px 374.876px"
    },
    id: "el5shh17k6ava",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.89,385.06c1.14-1.07,2.36-2.12,3.59-3.07h0s-7.83,5.5-11.31,3.51c-2.25-1.28-1.36-3.1-1.35-3.66s-7.83-3.95-9.92-4h0c-.55.35-1,.66-1.31.8-5.29,2.54-5.81,5.35-4.64,8.76,1.38,2.06,6.27,3.94,12.35,3.5C300.27,390.57,306.2,387.6,308.89,385.06Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "297.956px 384.402px"
    },
    id: "el6vwtsiczd4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,380.17c-4.21,2-2.3,2.69-1.07,2.77s8.21-4.64,12.4-8.43c4.37-3.95,7.63-9.07,9.25-10.52.61-.54,1.26-1.2,1.83-1.82-.19-.93-.34-1.78-.46-2.22-.22-.79-.56-.94-.56-.94a5.3,5.3,0,0,1-.66,1.71,10.82,10.82,0,0,1-1.14.84,20.2,20.2,0,0,0-1.64,2.14,18.2,18.2,0,0,1-1.71,2.36C313.07,371.06,304.48,378.15,300.27,380.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "310.182px 370.976px"
    },
    id: "ele5key2wj8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46,382.29a.43.43,0,0,0,.26-.11.42.42,0,0,0,0-.6c-1.34-1.39-7.4-4.47-10.57-3.9a.42.42,0,0,0-.34.5.43.43,0,0,0,.5.34c2.95-.53,8.73,2.54,9.78,3.64A.43.43,0,0,0,299.46,382.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.324px 379.952px"
    },
    id: "el5niido1nsf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,379.73a.43.43,0,0,0,.28-.72c-1.33-1.38-7.4-4.46-10.57-3.89a.41.41,0,0,0-.34.49.43.43,0,0,0,.5.34c3-.52,8.73,2.55,9.79,3.64A.44.44,0,0,0,303.07,379.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.948px 377.39px"
    },
    id: "elte6ni2fhzpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,377.28a.46.46,0,0,0,.27-.11.43.43,0,0,0,0-.6c-1.33-1.39-7.4-4.47-10.56-3.9a.44.44,0,0,0-.35.5.43.43,0,0,0,.5.34c3-.53,8.73,2.54,9.79,3.64A.41.41,0,0,0,306.69,377.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.563px 374.942px"
    },
    id: "elp7iglfnemif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,374.55a.47.47,0,0,0,.27-.12.43.43,0,0,0,0-.6c-1.33-1.38-7.41-4.46-10.56-3.89a.43.43,0,0,0-.35.49.43.43,0,0,0,.5.35c2.95-.53,8.73,2.54,9.79,3.64A.44.44,0,0,0,310,374.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.873px 372.211px"
    },
    id: "el1a207dgat7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,371.82a.43.43,0,0,0,.26-.11.42.42,0,0,0,0-.6c-1.84-2-8.13-4.46-11.3-3.88a.41.41,0,0,0-.34.49.43.43,0,0,0,.5.34c2.85-.51,8.88,1.88,10.51,3.63A.45.45,0,0,0,313.26,371.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "307.759px 369.483px"
    },
    id: "elhq0jyie2cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.2,247.11l-16,4S285.9,265.65,274,275.81c-3.38,2.9-4.24,7.61-4.38,9.54-1,13.8.72,47.93.72,47.93,2.09,3.07,13.82,3.78,17.67,1,0,0,1.43-10.59,3-20.37,1.4-8.44,1.63-11.44.94-16.39l17.64-7.73L332.06,275C340.69,268.48,329.2,247.11,329.2,247.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.29px 291.565px"
    },
    id: "el1sqvje280m2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,274.22c-5-2.9-10.27-9.35-10.93-12.62-.15,6,5.23,12.74,5.23,12.74s-19.26,14.27-23.29,18-3.73,4.35-3.21,8.48a110,110,0,0,1,.13,15c.11-.65.21-1.29.32-1.93,1.4-8.44,1.63-11.44.94-16.39l17.64-7.73L332.06,275h0a9.2,9.2,0,0,0,.87-.77,3.07,3.07,0,0,0,.25-.26c.19-.2-5.46-.7-5.29-.92l.24-.31q.25-.35.48-.72l.16-.26c.2-.35.39-.71.56-1.08a.08.08,0,0,1,0-.05c.16-.36.3-.73.43-1.1l.11-.32c.1-.3.19-.61.28-.93l.09-.33c.09-.35.17-.72.24-1.08,0-.06,0-.12,0-.19.08-.45.16-.91.22-1.37Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "311.763px 288.71px"
    },
    id: "elsaohs417kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.59,258.74c1.73,8.13.89,20.36-5.55,26.1-8.43,7.49-33.62,23-33.62,23,1.81,4.41,1.58,8,1.12,14.48-.66,9.32-3.22,19.7-4.17,27.38a30.8,30.8,0,0,1-18.9.36s-2.14-24.32-2.77-30.46c-1.57-15.2-2.47-19.21,1.07-26.44,4.27-8.69,19.75-18.9,19.75-18.9l-2.09-25.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "333.346px 300.291px"
    },
    id: "eltqggxooy8iq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-57",
    className: "animable",
    style: {
      transformOrigin: "312.362px 225.762px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.28,207.57c-1.2.2-1,1.35,0,1.87,2.37,1.26,5.39,0,7.15.18.43.1,5.91,2.23,6.46,3.32-1.34-.07-5.55-.6-6.89-.59a46.31,46.31,0,0,0-4.59.8,4.54,4.54,0,0,0-1.6.47c-.32.24-.39,1.14.55,1.63,1.68.88,3.79,0,5.68,0,.92,0,3.84.1,5.2,1.41-2.7.25-4.24.95-7.85,2.75-.42.21-.41.47-.28.75a1.63,1.63,0,0,0,1.27.8c1.26.15,2.67-.66,4.4-1.08a11.5,11.5,0,0,1,5.46.29,4.89,4.89,0,0,1,1.81.9,23.93,23.93,0,0,1,1.8,1.83,8.55,8.55,0,0,0,9.43,1.55,1.22,1.22,0,0,0,.52-.4,1.24,1.24,0,0,0-.08-1.12c-1.54-3.54-4.56-6.16-7.15-9-.85-.94-7.39-7.88-7.67-8.09-.12-.09-9.61,1-9.89,1.05C260.14,207.11,258.45,207.38,257.28,207.57Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "271.175px 215.532px"
    },
    id: "elz7w7aj6zyfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,218.25C312.29,218.11,297,216.7,293,216a21.78,21.78,0,0,1-12.09-6.45c-3.56-3.55-4.33-3.51-6.88-4.06-1.59-.33-5.34-1.56-5.48-1.6a4.19,4.19,0,0,0-1.69,0c-.3,0-1.54.2-1.84.24-1.73.24-2.78.48-4.5.73a7,7,0,0,0-1.58.33.59.59,0,0,0-.28.18.57.57,0,0,0,.08.62,3.83,3.83,0,0,0,2.66,1.55,13.46,13.46,0,0,0,3.17,0c.64-.05,1-.13,2.31-.23a2.92,2.92,0,0,1,1.52.36,35.49,35.49,0,0,1,6.66,3.64,12.47,12.47,0,0,1-6.59-.92c-1.92-.85-2.52,1.45-.35,3.18,2.49,2,4.89,1.49,8.13,4.22s1.75,7.17,7.29,8.25a68.29,68.29,0,0,1,9.81,3c4.68,1.66,15.95,4.74,20.5,5.93Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "286.226px 219.387px"
    },
    id: "elplrnwdlmr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,211.32a15.23,15.23,0,0,1,3.95.6c.49.18-.07-.9-2.09-1.49s-3.32,0-3.89-.36Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "276.043px 211.005px"
    },
    id: "elyrhavcy0qk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.22,187.23c-5.66,2.27-10.47,6.23-12,12.94-1.7,7.37-3.74,17.76-3.74,17.76l-20-2.22s1.2,5.59-.86,13.64c0,0,6.09,2,14.51,4.55,11.11,3.41,14,3.94,18.7-1.26s9.78-27.12,9.78-27.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "314.115px 211.867px"
    },
    id: "elwfzu0tpzh1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,234.54c-.34,6.88-4.72,11.52-11.49,19a175.45,175.45,0,0,1-13.09,12.82l25.3-15.19s6.62-6.88,6.19-14.86-3.3-25.6-3.3-25.6S312.49,227.67,312.16,234.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "303.335px 238.535px"
    },
    id: "ele7sfdzkx8og",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele6kwwtat1nb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.16,234.54c-.34,6.88-4.72,11.52-11.49,19a175.45,175.45,0,0,1-13.09,12.82l25.3-15.19s6.62-6.88,6.19-14.86-3.3-25.6-3.3-25.6S312.49,227.67,312.16,234.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "303.335px 238.535px"
    },
    className: "animable",
    id: "elfqr4ngila6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-57",
    className: "animable",
    style: {
      transformOrigin: "340.215px 225.762px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-57",
    d: "M343.08,188.34s11.27,2.81,15.65,6.35a16.73,16.73,0,0,1,5.3,8.63c2.83,9.84,3,17.43,3,26.14v29.18s-8.47,12.62-37.1,7.38a21,21,0,0,1-17-15.12s1.27-7.59.9-25c-.44-21.19,1.66-25.13,3.38-28.73,1.81-3.77,6.39-7.39,10.17-7.83C333.93,188.56,341.7,188.29,343.08,188.34Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "339.98px 227.814px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.08,188.34s11.27,2.81,15.65,6.35a16.73,16.73,0,0,1,5.3,8.63c2.83,9.84,3,17.43,3,26.14v29.18s-8.47,12.62-37.1,7.38a21,21,0,0,1-17-15.12s1.27-7.59.9-25c-.44-21.19,1.66-25.13,3.38-28.73,1.81-3.77,6.39-7.39,10.17-7.83C333.93,188.56,341.7,188.29,343.08,188.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "339.98px 227.814px"
    },
    className: "animable",
    id: "el91liim5c5ks"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,190.47s-6.53,4.16-9.82,9.78c-5.45,9.29-7.83,22.88-8.68,34.34,1.09-28.6,2.67-33.58,5.42-39.05a24.37,24.37,0,0,1,7.61-8.61l5.25-.15Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "321.41px 210.685px"
    },
    id: "elurlf69txzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-57",
    className: "animable",
    style: {
      transformOrigin: "335.74px 175.497px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-57",
    className: "animable",
    style: {
      transformOrigin: "335.74px 175.497px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.41,156.51a5.72,5.72,0,0,0-4.87-3.19c-1.44-3.65-8.08-7.28-15.71-5.83C320.34,149.29,316.88,153,316,158a11.14,11.14,0,0,0,2.59,8.9l22.11-5.65a21.81,21.81,0,0,0,.73,3.14c1,3.31,4.88,6.81,4.88,6.81L347,176l1.22,6.77a93.54,93.54,0,0,0,3.22-12.84C352.42,164,351.83,159,350.41,156.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.903px 164.967px"
    },
    id: "el2fon3vr9y5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,164.3a1.13,1.13,0,0,1-1.57-.26c-.14-.24-.19-.54-.4-.71s-.7-.12-1.06-.19a1,1,0,0,1-.57-.36c-.2-.24-.28-.58-.51-.79-.49-.44-1.34-.07-1.9-.43-.32-.21-.47-.61-.79-.81a4.35,4.35,0,0,0-.63-.25,1,1,0,0,1-.58-.6c-.08-.23-.06-.65.19-.78a1.92,1.92,0,0,1,1,0,1.29,1.29,0,0,1,1.11,1.16.76.76,0,0,0,.7.85c.32,0,.65,0,1,0a.9.9,0,0,1,.79.49,2,2,0,0,1,.07.49c.12.75,1.21.46,1.71.71a.59.59,0,0,1,.25.22c.11.18,0,.42.1.63C346.84,164.21,347.38,164.21,347.8,164.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "343.774px 161.781px"
    },
    id: "el0n4myww9n1nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,165.79a1.13,1.13,0,0,1-1.57-.26c-.14-.24-.19-.54-.4-.71s-.7-.12-1.05-.19a1,1,0,0,1-.58-.36c-.19-.25-.27-.58-.51-.79-.49-.44-1.34-.07-1.89-.43-.32-.21-.47-.61-.8-.81a4.35,4.35,0,0,0-.63-.25,1,1,0,0,1-.57-.6c-.08-.23-.06-.65.19-.78a1.88,1.88,0,0,1,1,0,1.28,1.28,0,0,1,1.11,1.16.77.77,0,0,0,.71.85c.32.05.65,0,1,0a.88.88,0,0,1,.79.49,2.51,2.51,0,0,1,.08.49c.11.74,1.2.46,1.71.71a.59.59,0,0,1,.25.22c.1.18,0,.42.1.63C345.64,165.7,346.19,165.7,346.6,165.79Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "342.579px 163.27px"
    },
    id: "eldlomvkx1pdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,175.91c-2.18,2.11-5.08.68-5.08.68l1.14,13s-2.86,7.67-19.73,14.24c-.52-3.53,2.08-8.81,2.58-9.86l-.66-3.86s-.68.11-2.6.19c-3.19.15-8.3-1-9.33-5.06a35.57,35.57,0,0,1-.78-14.49c.13-.9-.51-2.17-.56-3.56a17.62,17.62,0,0,1,1.25-7.38c3.45-3.95,12.37-3.28,20.59-.16-.1,4.75,3.24,7.09,3.68,9.32a6,6,0,0,0,1.69,1.46c1.33.75,1.74-2,2.48-3.16s3.59-3.17,5.8-.22A7,7,0,0,1,353.77,175.91Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "337.164px 180.453px"
    },
    id: "el61qf4o1n9xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.58,165.41l3.56,1.32a2,2,0,0,0-1.16-2.5A1.86,1.86,0,0,0,333.58,165.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.413px 165.425px"
    },
    id: "elshtss6145ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,166.4l3.66-1.11a1.84,1.84,0,0,0-2.33-1.31A2,2,0,0,0,321,166.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.797px 165.149px"
    },
    id: "elaaxeq7h3019",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.65,169.2a1.55,1.55,0,1,1-1.78-1.27A1.55,1.55,0,0,1,335.65,169.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.122px 169.459px"
    },
    id: "elpm5pscu8h4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,169.34a1.55,1.55,0,1,1-1.79-1.27A1.42,1.42,0,0,1,324.88,169.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.352px 169.584px"
    },
    id: "eln4vpbey78lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.1,165.3l-.34,10.07-5.24-.66C325.82,170.06,328,166.25,330.1,165.3Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "327.31px 170.335px"
    },
    id: "els774439ggsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,169a1.18,1.18,0,0,0-.43-.19l-.27,0a5.42,5.42,0,0,0-.57,0,2.79,2.79,0,0,0-1.14.29c-.09.05,0,.25.07.25a11.69,11.69,0,0,0,1.19-.09,2.8,2.8,0,0,1,.5,0l.27,0,.11,0,.18,0,.09,0C339.33,169.28,339.26,169,339.19,169Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "338.007px 169.076px"
    },
    id: "elk30uuas28jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.48,170.56a1.22,1.22,0,0,0-.19-.12,2.2,2.2,0,0,0-.61-.16l-.36,0a1.51,1.51,0,0,0-.36.06c-.13,0,0,.29.07.29s.45,0,.67.06l.28.06.3.1c.08,0,.24.07.28,0A.22.22,0,0,0,338.48,170.56Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "337.745px 170.581px"
    },
    id: "elwi3dook799e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18,168.87a1.3,1.3,0,0,0-.42-.18l-.53-.11-.37,0-.24,0a.31.31,0,0,0-.24.08.23.23,0,0,0,.07.36l.08,0a1.23,1.23,0,0,0,.44.09l.48,0,.36,0a.7.7,0,0,0,.38,0C321.28,169.1,321.26,168.93,321.18,168.87Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "320.285px 168.857px"
    },
    id: "elw8645vmy3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,169.94a.91.91,0,0,0-.4-.06h-.36l-.63,0a.19.19,0,0,0-.17.25.34.34,0,0,0,.28.27h.06l.16,0h.49l.34-.05a.49.49,0,0,0,.28-.13C321.2,170.14,321.2,170,321.1,169.94Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "320.357px 170.139px"
    },
    id: "elc6ychx87a9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.64,161.62a5.68,5.68,0,0,0-2.89.13,16.2,16.2,0,0,1-2.94.37c-1.8,0-3.7-1.1-5.5-.48,0,0-.05.11,0,.1a6.93,6.93,0,0,1,2.86.33,12.13,12.13,0,0,0,2.73.55,11.07,11.07,0,0,0,3-.4c.45-.11.91-.21,1.37-.29a8.27,8.27,0,0,0,1.39-.25S335.66,161.63,335.64,161.62Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "329.974px 162.035px"
    },
    id: "elccjt6ugg2gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.2,168.16c.7,6.72-1,9.29-3.27,10-3.06,1-5.26-2.39-10.26-1.94a15.14,15.14,0,0,0-7.14,2.33c-1.34.81-3.49.75-3.93-.59a14.86,14.86,0,0,1-.6-4.61,39.79,39.79,0,0,0,.36,9.5c.57,2.93.78,4.08,2.72,5.69,2.45,2,6.94,2.94,13.35,1.84,7.15-1.23,9.3-4.08,10.13-5.89,3.2-7,.76-12.38,2-15.24C348.19,167.82,344.2,168.16,344.2,168.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.247px 179.485px"
    },
    id: "elh8r89v506qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,177.57c3.11-.25,3.92.63,4.24,3.17s.1,3.51-1.05,4-2.21.24-2.43-.61-.31-1.28-.1-1.6c.38-.58.19-.66-1.18-.63s-1.31.28-.82.69a2.86,2.86,0,0,1,.65,1.57c.13.65-.39,1.25-2,1.08-1.76-.2-2-2.08-1.91-4.09S326.81,177.85,330.33,177.57Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "330.209px 181.399px"
    },
    id: "el1gbk3y5773pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,178.86c-.26-.42-.7,0-1,.15a7.1,7.1,0,0,1-1.08.51,12.79,12.79,0,0,1-2.19.56c-.06,0-.06.14,0,.15a4.72,4.72,0,0,0,2.36-.08,5.76,5.76,0,0,0,1-.41,2.07,2.07,0,0,0,.88-.63A.25.25,0,0,0,332.65,178.86Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "330.503px 179.511px"
    },
    id: "elysx3xmw45x",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,187.8l.16,1.52c-4.7,8.33-8.44,16.2-8.71,32-.25,14.25,0,27.22,0,40.19s-4.68,33.9-9,42.85c0,0,17.5-10.64,25.1-15.52,9.39-6,10.05-13.38,10.62-21.77s.41-47.66.41-47.66c-.81-17.54-1.92-22.68-1.92-22.68Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "350.195px 246.08px"
    },
    id: "el9wm8fa3duu",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "360.24 279.29 355.72 279.29 355.72 301.71 360.13 300.34 360.24 279.29",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "357.98px 290.5px"
    },
    id: "elu0g703f9d6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.94,274.24l-23.66,13.67,9,5.21,27.09-15.64-5.6-3.23A6.86,6.86,0,0,0,357.94,274.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "352.325px 283.227px"
    },
    id: "el7tc35xwtaou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp6hophnuxqn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.94,274.24l-23.66,13.67,9,5.21,27.09-15.64-5.6-3.23A6.86,6.86,0,0,0,357.94,274.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "352.325px 283.227px"
    },
    className: "animable",
    id: "elzqmk9g8w8e"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "370.4 279.9 370.4 277.48 343.31 293.12 343.31 295.55 370.4 279.9",
    style: {
      fill: "#3293C4",
      transformOrigin: "356.855px 286.515px"
    },
    id: "el3orie0axlhx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elilssatmoz9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "370.4 279.9 370.4 277.48 343.31 293.12 343.31 295.55 370.4 279.9",
    style: {
      opacity: 0.3,
      transformOrigin: "356.855px 286.515px"
    },
    className: "animable",
    id: "elcmkq1p5g39j"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "334.28 287.91 334.28 290.33 343.31 295.55 343.31 293.12 334.28 287.91",
    style: {
      fill: "#3293C4",
      transformOrigin: "338.795px 291.73px"
    },
    id: "el8tkiq5tvie4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzr1ccp56cl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "334.28 287.91 334.28 290.33 343.31 295.55 343.31 293.12 334.28 287.91",
    style: {
      opacity: 0.15,
      transformOrigin: "338.795px 291.73px"
    },
    className: "animable",
    id: "elm2jen9w1axk"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-57",
    className: "animable",
    style: {
      transformOrigin: "229.05px 229.453px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Arm--inject-57",
    d: "M210.33,158.8c11,.91,13.93,4.92,18.73,19.76,4.61,14.26,6.12,17.87,7.06,20.67s2.22,7.24,3.42,11.1c3.37,10.82,3.69,15.45,5.58,17.18a6.8,6.8,0,0,0,3.13,1.52,11.65,11.65,0,0,0,3.83.15,17.34,17.34,0,0,1,3.85,0,8.64,8.64,0,0,0,2.3.33,8.94,8.94,0,0,1,2.23-.26,5.6,5.6,0,0,1,2.23.84,12.53,12.53,0,0,0,3.09,1.23c2.26-.55,3,.46,2.35,1.65-.77,1.4-2.74,2.24-4.2,2.69a41.52,41.52,0,0,1-11,2.27c-1.47.09-3.66,0-4.58,1.37s1.6,1.2,2.36,1.22a7.9,7.9,0,0,1,3.35.56c2.68,1,3,4.19-.22,3.68-2.13-.35-2.79.06-4.93.14s-4.58.16-6.5-.82a19.44,19.44,0,0,1-2.39-1.59c-1-.71-2.45-1.19-3.18-2.17a12.15,12.15,0,0,1-2-4.82,10.56,10.56,0,0,0-.87-2.74c-.72-1.43-1-2.9-1.72-4.34s-1.45-2.91-2.2-4.35c-1.61-3.09-3-4.44-4.59-7.55a69.4,69.4,0,0,1-3.62-9.3c-1.76-5.81-10.23-23.72-10.23-23.72S204.15,166.29,210.33,158.8Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "238.118px 201.872px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-57",
    className: "animable",
    style: {
      transformOrigin: "246.744px 282.479px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.74,253.4c-4.42-9.22-9.21-19.38-12.48-25.5a14.21,14.21,0,0,0-10.49-7.76,242.18,242.18,0,0,0-43.2-3.12l-23.88,25.09c.22.22,23.76,6.22,23.76,6.22s35.77-4.14,38.56-4.67a15.24,15.24,0,0,0,3,8.15,93.66,93.66,0,0,0,9.74,10.57c3.52,3.46,7,6,8.38,10.37a6,6,0,0,1,.21,2.26c-.2,2.3-.3,4.63.73,6.81,2.23,5.48,9,2.29,12.78,6,1.65,1.34,5.21,5.73,7,6.84,2.51,1.53,5.75,1.21,8.54.29a23.06,23.06,0,0,0,7.37-4,8.31,8.31,0,0,0,1.48-1.54,7.32,7.32,0,0,0,.68-1.08c1-2,0-3.34-2.05-3.93-1.57-.44-3.21-.58-4.8-.9-2.89-.59-5-2.35-7.08-4.34C301.5,272.27,295.15,262.61,290.74,253.4Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "262.001px 256.353px"
    },
    id: "elequtar5p2jv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brace--inject-57",
    className: "animable",
    style: {
      transformOrigin: "265.028px 239.672px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.71,218.51c-6.76,6.85-6.86,19.07-1,26.72l4.43-.86c-4.51-7.13-5.47-18.26,1.9-25.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.754px 231.87px"
    },
    id: "elkz6f2gt2t8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,217.48c-7.32,8.23-7,21.21-.9,28.8l4.82-.55c-4.84-7.26-6.47-19.72,1.67-27.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.373px 231.88px"
    },
    id: "ellu3im6zlwpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.8,247.63c6.35-.06,16.78-6,18.78-11.2l2.48,4.49c-5.86,8.52-13.11,11.46-19.39,10.89C265.67,251.81,263.8,248.5,263.8,247.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.43px 244.154px"
    },
    id: "elhy14y2uzdsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,258.55c6.36-.06,14.81-6,16.2-11.21l2.38,4.53c-2.15,5.38-9.07,10.53-15.34,9.95Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.93px 254.602px"
    },
    id: "els7bbcjip1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.19,260.21a.58.58,0,0,1-.49-.26l-14.13-21.32a.59.59,0,0,1,.16-.8.6.6,0,0,1,.81.16l14.13,21.32a.58.58,0,0,1-.17.8A.5.5,0,0,1,281.19,260.21Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "274.12px 248.974px"
    },
    id: "elahwsefwglm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.66,235.63a.57.57,0,0,1-.58-.55.58.58,0,0,1,.56-.6l19.36-.65a.56.56,0,0,1,.6.56.57.57,0,0,1-.56.59l-19.36.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "251.34px 234.729px"
    },
    id: "elvauptqbk9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,231.52a2.39,2.39,0,0,0-1,2.2,7.54,7.54,0,0,0,3.4,5.89,2.37,2.37,0,0,0,2.4.23l2.17-1.25a2.38,2.38,0,0,0,1-2.2,7.52,7.52,0,0,0-3.39-5.88,2.4,2.4,0,0,0-2.4-.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.045px 235.059px"
    },
    id: "el6as2u2gkh6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,239.61a2.08,2.08,0,0,0,3.4-2,7.5,7.5,0,0,0-3.4-5.88,2.07,2.07,0,0,0-3.4,2A7.54,7.54,0,0,0,263,239.61Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "262.997px 235.661px"
    },
    id: "elpn4hlzi2lkj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,343.63c-1.08-1.23-2.38-2.22-3.55-3.36-2.1-2.06-2.92-4.68-3.6-7.49-2.61-9.81-2.42-21.34-1.43-31.51,1.08-10.94,1.75-18.26,2.48-25.37.76-7.48,1.21-13-2.64-16.54-10.14-9.38-11.52-10.81-25.36-22.76,3.74-2.36,9.77-12.35,9.37-19.35l-49,3.15c-.25,4.33.43,15.73,2,20.42,2.21,6.52,7.82,13.63,18.38,19.61,9.93,5.62,22.42,13.73,24.89,15.13a41.05,41.05,0,0,0-.77,11.77c.34,4.29,1.94,10.32,2.84,15,1,5.32,1.64,7.36.43,11.73a7.44,7.44,0,0,1-1,2c-1,1.61-2.54,3.57-1.68,7.46s6.24,5.32,7.42,10.48c.66,2,1.27,7.64,2.2,9.55,1.28,2.65,4.17,4.13,7,4.87a22.82,22.82,0,0,0,8.39.6,8.73,8.73,0,0,0,2.08-.48,8,8,0,0,0,1.15-.55C246.25,346.88,246.14,345.26,244.71,343.63Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "208.353px 283.209px"
    },
    id: "ely5o7xgagihj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,219.35c-.19,5.25-.06,16,2,22.81s8.24,13.22,19.26,19.41,16,8.83,16,8.83a27.72,27.72,0,0,1,7-13.69c6.08-6.13,11.87-6.46,11.87-6.46l-1.61-1.37,17.31-2.41a22.55,22.55,0,0,1,.2-29.16l-17.3-1.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "206.224px 243.095px"
    },
    id: "elkeqtyqo4xjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,237.3a12.15,12.15,0,0,0,4.53-10.49C219,233.93,211,236.25,211,236.25l13.89,12.63,3.72-.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "219.805px 237.845px"
    },
    id: "el6kjs8ccp1qw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-57",
    className: "animable",
    style: {
      transformOrigin: "179.934px 184.127px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-57",
    className: "animable",
    style: {
      transformOrigin: "179.934px 184.127px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-57",
    className: "animable",
    style: {
      transformOrigin: "179.934px 184.127px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-57",
    className: "animable",
    style: {
      transformOrigin: "179.934px 184.127px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.72,180.56c-.57-16.41-8.52-20.59-11.39-21.76l-17.93-2.07c-3.55.42-19.69,5.63-19.69,5.63s-5.2,5.59-4.8,16.1c.27,7.08.75,8.82,1.8,20.07.76,8.16,0,17,0,29,18.47,5.51,42.48.76,55.37-11.72C224,206.39,221.87,185,221.72,180.56Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "196.484px 193.265px"
    },
    id: "elx3f0leglldj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-57",
    d: "M172.71,162.36c-11.28,2.23-13,9.9-13.82,25.48-.76,15-1.28,18.84-1.46,21.79s-.27,7.57-.43,11.61c-.45,11.32.44,15.88-.94,18a6.8,6.8,0,0,1-2.62,2.28c-1.09.6-1.41.61-3.67,1.15a17.44,17.44,0,0,0-3.71,1,9.16,9.16,0,0,1-2.14.92,8.69,8.69,0,0,0-2.22.32,5.46,5.46,0,0,0-1.94,1.39,11.88,11.88,0,0,1-2.66,2c-2.33.06-2.8,1.23-1.85,2.22,1.12,1.14,3.24,1.45,4.76,1.5a41.28,41.28,0,0,0,11.21-.66c1.44-.28,3.52-1,4.77.14s-1.23,1.57-2,1.79a8,8,0,0,0-3.09,1.41c-2.32,1.69-1.79,4.82,1.16,3.5,2-.89,2.72-.67,4.8-1.14s4.47-1,6.07-2.48a20.47,20.47,0,0,0,1.89-2.15c.79-.95,2.06-1.79,2.52-2.93a12.27,12.27,0,0,0,.66-5.17,10.59,10.59,0,0,1,.13-2.87c.32-1.56.24-3.07.54-4.64s.64-3.18,1-4.76c.76-3.4,1.75-5.07,2.47-8.49a68.45,68.45,0,0,0,1.1-9.91c.19-6.08,3.73-25.57,3.73-25.57S180.62,168,172.71,162.36Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "156.3px 210.438px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-57",
    className: "animable",
    style: {
      transformOrigin: "197.888px 139.294px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.63,151.37c-.71-4-4.7-8.08-6.52-11.53s-2.79-5.91-2.62-9.05c.1-1.86,1.25-4.4,2.62-4.94A8.63,8.63,0,0,1,186.37,115a31.68,31.68,0,0,0,3.8-1.1c1.49-.64,1.82-1.85,3-2.89,2.06-1.78,5.57-1.85,6.92.81,1.37-1.8,3.25-1.77,5.43-1.24a3.7,3.7,0,0,1,2.87,4.16c2.89-1.65,5.57.38,5.85,2.08.2,1.26,0,2.32.78,3.44s2.69,1.22,3.21.19c.32,1.79-.37,3.16-2.31,3.07a4,4,0,0,1,.54,3.41,3.71,3.71,0,0,1-3.33,2.58,5.64,5.64,0,0,1-3.1,4.81c-2.92,1.43-6.16,1.91-9.32,2.59l-3.74.81c-.22,0-1.35.13-1.48.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.888px 130.554px"
    },
    id: "el7ll4i06om3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,146.27a3.84,3.84,0,0,0,4.68-.17v14.06s6.27,8.28,17,8.69c.74-2.35.71-7-.83-9.2v-4.56a39.69,39.69,0,0,0,4.72-.25,8.28,8.28,0,0,0,6.59-6.33,35.82,35.82,0,0,0,.3-13.52,11.65,11.65,0,0,1-.2-3.28,15.44,15.44,0,0,0-1-7c-3.46-2.73-13.16-3.22-20.52,1.34,1.62,3.76.66,7.6-2.53,9.31.16,1.18.33,4.19-1.62,4.15-1.41,0-1.52-1.79-3-3.34s-4.84-1.93-6.12.38A7.59,7.59,0,0,0,181.77,146.27Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "196.578px 145.743px"
    },
    id: "elgoi0wifj1dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,155.09c-5-.54-8.71-1.05-11.32-4.61a31.18,31.18,0,0,1-3-5.83,24.13,24.13,0,0,0,2.18,7.33c1.27,2.27,4.34,4.15,12.1,4.75Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "195.45px 150.69px"
    },
    id: "elvyxpon4i42m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,135.65a1.39,1.39,0,1,1-2.78,0,1.39,1.39,0,1,1,2.78,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "199.83px 135.65px"
    },
    id: "el2puqc9f95vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,131.67l-3,1.56a1.77,1.77,0,0,1,.76-2.35A1.66,1.66,0,0,1,199.8,131.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.208px 131.969px"
    },
    id: "elzqfn88q515",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.32,131.67l-3.31-.88a1.65,1.65,0,0,1,2-1.25A1.8,1.8,0,0,1,212.32,131.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.686px 130.582px"
    },
    id: "elgsbanv8tujf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.12,134.78a1.39,1.39,0,1,1-1.38-1.45A1.41,1.41,0,0,1,212.12,134.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.731px 134.72px"
    },
    id: "elovgecvpagy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,140.28l-4.82,2.19L203.75,133C205.54,132.33,207.89,136.68,210.14,140.28Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "206.945px 137.701px"
    },
    id: "el94hknzfxddq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,144.85l5.83,1.19a2.93,2.93,0,0,1-3.45,2.42A3.12,3.12,0,0,1,200.1,144.85Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "202.989px 146.682px"
    },
    id: "elqikve9fzq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81,145.79a3.47,3.47,0,0,0-.72,0,3.1,3.1,0,0,0,2.39,2.65,3,3,0,0,0,1,0A2.72,2.72,0,0,0,200.81,145.79Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "201.785px 147.127px"
    },
    id: "eld05muc6i3",
    className: "animable"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-57",
    className: "animable",
    style: {
      transformOrigin: "330.613px 240.336px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.89,208.59c-1.64-6.74-4.32-9.9-7-10.94-4.37.94-12.28,11.68-14.39,20.69l-7.6,28.77s-16.53,12.1-22.37,15.83c-2.86,1.82-6.3,4-9.29,4.35A14.82,14.82,0,0,1,309,267a11.63,11.63,0,0,0-4.4.08c-1.11.23-2.18.63-3.3.85-.88.18-1.79.29-1.79.29.89,1.25,1.79,2.43,2.68,3.54a.57.57,0,0,1,.4.2c.14.23-.1.5-.31.66-.46.35-.94.68-1.43,1a20.86,20.86,0,0,1-4.9,2.29c-.91.29-1.85.48-2.78.72-.66.17-1.32.32-2,.46s-1.24.16-1.88.24a8.24,8.24,0,0,0-1.71.35c-.57.19-2.17,1.1-1.31,1.83a1.31,1.31,0,0,0,.47.24,9.54,9.54,0,0,0,1.67.35l2.33.37a12.39,12.39,0,0,1,2.09.38c1.08.39,2,1.24,3.2,1.31a13.65,13.65,0,0,0,2-.26c2.25-.22,4.22,1.48,6.43,1.95a9,9,0,0,0,5.22-.73c1.28-.53,2.67-.86,4-1.32,2.58-.9,5.11-1.92,7.69-2.79l.27-.09c5.3-1.71,18-7.58,30.71-13.91,7.58-3.79,8.32-6.65,10.88-14.14,2-5.76,3.88-9,6.76-17.9C373.29,223,374.79,212.26,373.89,208.59Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "330.084px 240.806px"
    },
    id: "el3vlquy2fm7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.37,196.71s6.32,3.06,7.93,8.51,1.09,10.73-1.69,21.85-8.94,24.92-10,28.91-3.5,6.89-10.64,10.4-19.61,9.43-19.61,9.43,0-5.25-1.83-8.92C328,262,325,261.33,325,261.33l18.77-14.22s9.13-30.34,10.54-35.06S360.31,199,366.37,196.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "350.103px 236.26px"
    },
    id: "elp4dockuqwa",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-57",
    className: "animable",
    style: {
      transformOrigin: "250.47px 97.6558px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-57",
    className: "animable",
    style: {
      transformOrigin: "250.47px 97.6558px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-57",
    className: "animable",
    style: {
      transformOrigin: "250.47px 97.6558px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.06,82.41a23.11,23.11,0,0,0-5.7,16l.24,2.63a23.11,23.11,0,0,0,46-3.06l-.11-2.64a23.12,23.12,0,0,0-40.41-12.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "250.473px 97.736px"
    },
    id: "elkb0il7lziw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.61,81.09a25.13,25.13,0,0,0-.61,32.39l-2.68,7.32a1.47,1.47,0,0,0,2.05,1.8l6.91-3.61a25.09,25.09,0,1,0-5.67-37.9Zm34.12-.83a23,23,0,0,1,7.74,15.13l.11,2.64a23.11,23.11,0,0,1-46,3l-.24-2.63a23.12,23.12,0,0,1,38.37-18.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "250.47px 97.6558px"
    },
    id: "el4nme7ydyvk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-57",
    className: "animable",
    style: {
      transformOrigin: "250.42px 97.6752px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.43,109.15a3.15,3.15,0,0,1-2.3-1l-7.11-7.6a3.14,3.14,0,1,1,4.58-4.29l4.62,4.94,10.94-13.86a3.14,3.14,0,0,1,4.93,3.89L249.89,108a3.11,3.11,0,0,1-2.33,1.19Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "250.42px 97.6752px"
    },
    id: "el5iidoozt7g4",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wheelchair--inject-57",
    className: "animable animator-active",
    style: {
      transformOrigin: "106.266px 355.068px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wheelchair--inject-57",
    className: "animable",
    style: {
      transformOrigin: "106.266px 355.068px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wheel-chair--inject-57",
    className: "animable",
    style: {
      transformOrigin: "111.579px 355.068px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.37,318.33l-1.7-1.08a25.09,25.09,0,0,0-11.81-4.19h-.31a16.52,16.52,0,0,0-1.87,0,20.45,20.45,0,0,0-14.3,7.26l-.21.23c-.12.14-.24.28-.35.43l-.22.3-.28.36c-.17.24-.33.48-.49.74l-.17.27-.21.37,0,0a20.37,20.37,0,0,0-2.84,9.68l0,.81-.06,1.15-.08,2c-.68,17.43,10.73,39.11,25.49,48.41l1.7,1.08a25.09,25.09,0,0,0,11.81,4.19h.1l.15,0h.93c.2,0,.41,0,.61,0l.3,0,.17,0a20.5,20.5,0,0,0,14.63-7.73l.44-.57.05-.07c.16-.23.33-.46.48-.7a20.36,20.36,0,0,0,3.44-10.6l.08-2,.08-2C145.54,349.3,134.13,327.63,119.37,318.33ZM111,379.77c-12.46-7.86-22.09-26.16-21.52-40.87s11.14-20.29,23.6-12.43,22.09,26.16,21.52,40.87S123.43,387.63,111,379.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "114.697px 351.687px"
    },
    id: "eladj82fp6r9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,321.09l-1.7-1.08c-7.3-4.6-14.05-5.31-19.09-2.75l-.39.21-.1.06-.45.26-.44.29a10.25,10.25,0,0,0-.85.62l-.41.34a9.12,9.12,0,0,0-.79.74c-.13.12-.25.26-.37.39l-.37.41c-.12.14-.24.28-.35.43l-.22.3-.28.36c-.17.24-.33.48-.49.74l-.17.27-.21.37-.21.37a15.5,15.5,0,0,0-.68,1.42c-.12.26-.23.52-.33.79,0,0,0,0,0,0-.19.48-.36,1-.52,1.51-.08.28-.16.56-.25.85s-.17.67-.24,1c0,.15-.07.32-.1.48s-.11.56-.16.84-.11.63-.16.95a.88.88,0,0,1,0,.16c0,.28-.07.56-.1.84l0,.34c0,.31-.07.62-.09.94l-.06,1.15-.08,2c-.68,17.43,10.73,39.11,25.49,48.41l1.7,1.08a24.9,24.9,0,0,0,12.06,4.21h.93c.2,0,.41,0,.61,0l.3,0a6,6,0,0,0,.61-.06l.53-.07c.18,0,.35,0,.52-.09.33-.06.65-.14,1-.23l.4-.11.44-.14a2.35,2.35,0,0,0,.37-.14,6.86,6.86,0,0,0,.79-.32l.39-.18.1-.05.15-.08.25-.12c5-2.71,8.19-8.67,8.53-17.3l.08-2C140.3,352.07,128.89,330.39,114.13,321.09ZM111,379.77c-12.46-7.86-22.09-26.16-21.52-40.87s11.14-20.29,23.6-12.43,22.09,26.16,21.52,40.87S123.43,387.63,111,379.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "112.091px 353.091px"
    },
    id: "el5alc1xduzvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,376.66c-3.82,4.2-10.17,4.58-17.19.15-11.08-7-19.64-23.25-19.13-36.34.23-5.84,2.23-10.06,5.37-12.32-2.22,2.42-3.6,6.11-3.79,10.91-.51,13.08,8.06,29.34,19.13,36.33C118.79,379.25,124.4,379.46,128.28,376.66Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "110.109px 354.062px"
    },
    id: "el8tevmx9kc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli25c27rnn7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.28,376.66c-3.82,4.2-10.17,4.58-17.19.15-11.08-7-19.64-23.25-19.13-36.34.23-5.84,2.23-10.06,5.37-12.32-2.22,2.42-3.6,6.11-3.79,10.91-.51,13.08,8.06,29.34,19.13,36.33C118.79,379.25,124.4,379.46,128.28,376.66Z",
    style: {
      opacity: 0.2,
      transformOrigin: "110.109px 354.062px"
    },
    className: "animable",
    id: "eleksgfeu1xx"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,326.47c-12.46-7.85-23-2.29-23.6,12.42s9.06,33,21.52,40.88,23,2.29,23.6-12.43S125.51,334.33,113.05,326.47Zm-2,50.34c-11.07-7-19.63-23.25-19.12-36.33s9.9-18,21-11.05,19.64,23.25,19.13,36.33S122.16,383.79,111.08,376.81Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "112.01px 353.127px"
    },
    id: "el98s9n2w2d76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,359.23l-.12-.7L113.82,353l-.39-.61,13.44-7.07-.3-.56-13.43,7.07-.29-.66,5.43-17.51-.51-.49-5.34,17.22-.6-.74-3.71-22.59-.68-.21,3.66,22.28-.71-.13L98.91,327.23l-.57.28,11.49,21.82-.29.67L93.07,334.2c-.08.22-.15.44-.22.67l16.7,16,.27.91L92.3,346.37c0,.23.07.46.11.69l17.81,5.53.39.61-13.7,7.21c.1.19.19.38.29.56l13.7-7.21.29.66-5.58,18,.51.49,5.49-17.71.61.75L116,379.19l.68.2-3.77-22.93.71.14,11.74,22.28.55-.31L114.21,356.3l.3-.66,16.6,15.92c.07-.23.13-.45.2-.69l-16.82-16.12-.27-.92Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "111.96px 353.12px"
    },
    id: "elyatw0xb947",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,343.61c-2.14-1.35-4.1-1.5-5.53-.68-.3.18-.66.32-1,.53l-.3.18,0,0h0a2.88,2.88,0,0,0-.39.3l-.09.08c-.11.1-.21.21-.31.32l-.11.13c-.09.11-.17.23-.25.35l-.13.2a3.84,3.84,0,0,0-.18.35c0,.09-.09.19-.13.28l-.14.35c0,.12-.07.25-.11.37l-.09.33c0,.16-.06.33-.09.5a2.93,2.93,0,0,0,0,.29,7.49,7.49,0,0,0-.07.85A17,17,0,0,0,111.66,362a8.81,8.81,0,0,0,.77.44c.16.08.31.14.46.2l.3.14.31.1.43.14.17,0c.19,0,.37.08.55.1h0a4,4,0,0,0,2.53-.48c.38-.21.72-.36,1.15-.59,1.38-.76,2.28-2.44,2.37-4.84A17,17,0,0,0,113.57,343.61Zm-2.77,14.7c-1.28-1.08-3-4.26-3.67-6a15.67,15.67,0,0,0,1.31.87c2,1.12,2-.29,2.74.72s.53,3.38-.15,4.59A.83.83,0,0,1,110.8,358.31Zm4.25-9a2.52,2.52,0,0,0-.33.13l-1.21.63a1.52,1.52,0,0,0-.61.56,10.67,10.67,0,0,1-1.82-5.83A12.86,12.86,0,0,1,116,349a1.19,1.19,0,0,1,.08.22A4.42,4.42,0,0,0,115.05,349.35Zm-5.8-1.25c.56,2.35,1.52,2.75,1.55,3.51-1.5-.3-3.9-1.87-4-3.34a5.86,5.86,0,0,1,1.48-3.85C108.9,344.73,108.8,346.18,109.25,348.1Zm3.88,12.37c-.78-.77.14-1.44.61-2.94a4.2,4.2,0,0,0,.07-2.21c1.52,1.3,3.76,4.66,3.11,5.61l-.08.09A5.05,5.05,0,0,1,113.13,360.47Zm4-4.91c-1.59-2.3-2.28-1.56-2.64-2.77a1.55,1.55,0,0,1,.61-1.58,2,2,0,0,1,2.39.91,14.65,14.65,0,0,1,1.09,5.79C118.15,357.3,117.68,356.43,117.08,355.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.675px 352.793px"
    },
    id: "eljhv46go2xqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elymz5upmfc9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.57,343.61c-2.14-1.35-4.1-1.5-5.53-.68-.3.18-.66.32-1,.53l-.3.18,0,0h0a2.88,2.88,0,0,0-.39.3l-.09.08c-.11.1-.21.21-.31.32l-.11.13c-.09.11-.17.23-.25.35l-.13.2a3.84,3.84,0,0,0-.18.35c0,.09-.09.19-.13.28l-.14.35c0,.12-.07.25-.11.37l-.09.33c0,.16-.06.33-.09.5a2.93,2.93,0,0,0,0,.29,7.49,7.49,0,0,0-.07.85A17,17,0,0,0,111.66,362a8.81,8.81,0,0,0,.77.44c.16.08.31.14.46.2l.3.14.31.1.43.14.17,0c.19,0,.37.08.55.1h0a4,4,0,0,0,2.53-.48c.38-.21.72-.36,1.15-.59,1.38-.76,2.28-2.44,2.37-4.84A17,17,0,0,0,113.57,343.61Zm-2.77,14.7c-1.28-1.08-3-4.26-3.67-6a15.67,15.67,0,0,0,1.31.87c2,1.12,2-.29,2.74.72s.53,3.38-.15,4.59A.83.83,0,0,1,110.8,358.31Zm4.25-9a2.52,2.52,0,0,0-.33.13l-1.21.63a1.52,1.52,0,0,0-.61.56,10.67,10.67,0,0,1-1.82-5.83A12.86,12.86,0,0,1,116,349a1.19,1.19,0,0,1,.08.22A4.42,4.42,0,0,0,115.05,349.35Zm-5.8-1.25c.56,2.35,1.52,2.75,1.55,3.51-1.5-.3-3.9-1.87-4-3.34a5.86,5.86,0,0,1,1.48-3.85C108.9,344.73,108.8,346.18,109.25,348.1Zm3.88,12.37c-.78-.77.14-1.44.61-2.94a4.2,4.2,0,0,0,.07-2.21c1.52,1.3,3.76,4.66,3.11,5.61l-.08.09A5.05,5.05,0,0,1,113.13,360.47Zm4-4.91c-1.59-2.3-2.28-1.56-2.64-2.77a1.55,1.55,0,0,1,.61-1.58,2,2,0,0,1,2.39.91,14.65,14.65,0,0,1,1.09,5.79C118.15,357.3,117.68,356.43,117.08,355.56Z",
    style: {
      opacity: 0.2,
      transformOrigin: "112.675px 352.793px"
    },
    className: "animable",
    id: "elbfvcry3bcqa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,344.23c-4.16-2.61-7.68-.76-7.87,4.15A17,17,0,0,0,111.66,362c4.16,2.62,7.67.77,7.87-4.14A17.06,17.06,0,0,0,112.36,344.23Zm-1.93.45c1.52.08,5.06,3.19,5.52,4.27s-.86.63-2.1,1c-1.58.49-.9,2-1.8,1.61C110.73,351,108.92,344.6,110.43,344.68Zm-2.28-.32c.78.16.62,1.69,1.1,3.74.62,2.6,1.73,2.81,1.53,3.76-.29,1.4-5-.89-5.2-3S107.37,344.19,108.15,344.36Zm1.44,14.57c-1.61-1.36-4-6.09-3.94-7.07s1.25.42,2.79,1.29c2,1.12,2-.29,2.74.72C112.33,355.34,111.21,360.29,109.59,358.93Zm7.33,2c-.84,1.23-4.23.93-5,.16s.15-1.44.62-2.95c.59-1.9-.51-3,.17-3.31C113.69,354.34,117.77,359.69,116.92,360.93Zm-1-4.75c-1.59-2.3-2.28-1.56-2.64-2.77-.53-1.76,3.11-3.41,4.2-1.29s1.34,6.67.85,7.17S117.13,358,115.88,356.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.01px 353.118px"
    },
    id: "eluj650nvdfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,355.84c1.27.8,2.35.23,2.41-1.27a5.2,5.2,0,0,0-2.19-4.17c-1.27-.8-2.35-.23-2.41,1.27A5.2,5.2,0,0,0,111.9,355.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.01px 353.12px"
    },
    id: "eldhehtc1nt6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,409.48,167.78,390h0l-2.65-6.22a23.51,23.51,0,0,0-8.33-10.14l-.11,2.71a21,21,0,0,1,6.37,8.31l1.27,3-6.84-4.24-.1,2.58,8.48,5.25L174,410.36a1.12,1.12,0,0,0,1,.68,1,1,0,0,0,.48-.09A1.11,1.11,0,0,0,176.1,409.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "166.439px 392.341px"
    },
    id: "elpte1ydlo6oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.71,381.62c-3.4,5.87-2.67,13.55-2.66,16.16s-1.28,2.05-1.93-.07-2.28-10.77,1.33-18.12Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.948px 389.558px"
    },
    id: "elrt1ca3bui5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,400.5A16.75,16.75,0,0,0,150,387.11c-2.14-1.35-4.11-1.48-5.52-.61h0l-3.3,1.69L151.32,407l3.24-1.69v0C156,404.62,157,403,157.06,400.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "149.12px 396.475px"
    },
    id: "elyx5kq6f2gwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.51,388.93a16.73,16.73,0,0,1,7.05,13.39c-.19,4.82-3.65,6.64-7.73,4.07A16.75,16.75,0,0,1,138.78,393C139,388.18,142.43,386.36,146.51,388.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.17px 397.66px"
    },
    id: "elqj49mhugmma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,394.59a5.85,5.85,0,0,1,2.48,4.71c-.06,1.7-1.28,2.34-2.72,1.43a5.9,5.9,0,0,1-2.48-4.71C143.64,394.32,144.86,393.68,146.29,394.59Z",
    id: "elwhweejqx0m",
    className: "animable",
    style: {
      transformOrigin: "146.17px 397.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,381.28c-3.41,5.88-2.68,13.55-2.66,16.17s-1.28,2.05-1.93-.08-2.28-10.77,1.33-18.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "146.718px 389.23px"
    },
    id: "el8qe98occh4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,384.57l-30.92-20-.13,3.34,26.35,17h0l3.39,2.19.6.38a1.55,1.55,0,0,0,2.37-1.39l-.17-3.05Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "142.696px 376.143px"
    },
    id: "elbyyo2697tch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.68 439.36 118.85 430.01 168.49 403.87 183.32 413.23 133.68 439.36",
    style: {
      fill: "#3293C4",
      transformOrigin: "151.085px 421.615px"
    },
    id: "elt0lxgph5nbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.85 430.01 118.72 433.51 133.54 442.86 133.68 439.36 118.85 430.01",
    style: {
      fill: "#3293C4",
      transformOrigin: "126.2px 436.435px"
    },
    id: "elpt435a6swjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5qntjobmwex"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118.85 430.01 118.72 433.51 133.54 442.86 133.68 439.36 118.85 430.01",
    style: {
      opacity: 0.3,
      transformOrigin: "126.2px 436.435px"
    },
    className: "animable",
    id: "elys4bt712zo8"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "183.32 413.23 183.19 416.73 133.54 442.86 133.68 439.36 183.32 413.23",
    style: {
      fill: "#3293C4",
      transformOrigin: "158.43px 428.045px"
    },
    id: "el28y38h5etub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldgeq62kkz2o"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "183.32 413.23 183.19 416.73 133.54 442.86 133.68 439.36 183.32 413.23",
    style: {
      opacity: 0.15,
      transformOrigin: "158.43px 428.045px"
    },
    className: "animable",
    id: "el231i0t4zbku"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100,396.6a1.11,1.11,0,0,1,1.54-.35l.94.59a23.33,23.33,0,0,1,9.07,10.64l2.65,6.21h0l8.33,19.48a1.12,1.12,0,0,1-.6,1.47,1,1,0,0,1-.48.09,1.12,1.12,0,0,1-1-.68l-8.17-19.14-10.95-6.79a1.12,1.12,0,0,1,1.18-1.91l8.24,5.11-1.27-3a21.15,21.15,0,0,0-8.21-9.63l-.93-.59A1.11,1.11,0,0,1,100,396.6Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "111.23px 415.404px"
    },
    id: "elzqjvixq4lql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,409.22c-3.4,5.88-2.67,13.55-2.66,16.16s-1.27,2.06-1.93-.07-2.27-10.77,1.33-18.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "96.2379px 417.16px"
    },
    id: "elei20nqgoaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,428.1a16.72,16.72,0,0,0-7-13.39c-2.14-1.35-4.1-1.48-5.52-.61h0l-3.29,1.69,10.12,18.85,3.25-1.69h0C103.27,432.22,104.22,430.56,104.32,428.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "96.415px 424.095px"
    },
    id: "el68u7lfrl0xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.78,416.53a16.72,16.72,0,0,1,7,13.39c-.18,4.82-3.64,6.64-7.72,4.07a16.69,16.69,0,0,1-7-13.39C86.24,415.78,89.7,414,93.78,416.53Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "93.42px 425.269px"
    },
    id: "elq7blo3gxmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56,422.19A5.93,5.93,0,0,1,96,426.9c-.07,1.7-1.29,2.34-2.72,1.44a5.92,5.92,0,0,1-2.49-4.72C90.9,421.93,92.12,421.28,93.56,422.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "93.395px 425.263px"
    },
    id: "elqi9wbnn2l8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.74,408.88c-3.4,5.88-2.67,13.56-2.66,16.17s-1.27,2.05-1.93-.08-2.27-10.76,1.33-18.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "93.9779px 416.828px"
    },
    id: "ell14tu8e95y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,298,55.61,293l-12.07-7.61h0a1.46,1.46,0,0,0-1.49.07,4.59,4.59,0,0,0-2.2,3.49,1.48,1.48,0,0,0,.53,1.34h0l0,0h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "47.7236px 291.609px"
    },
    id: "elx5qg9n0xp4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,296.61c-.06,1.31.85,1.88,2,1.27a4.57,4.57,0,0,0,2.2-3.49c.05-1.32-.85-1.89-2-1.27A4.53,4.53,0,0,0,52,296.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "54.0996px 295.497px"
    },
    id: "elvo3xnkinn1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21,294.28a.78.78,0,0,1,.62-.07l.16.11,8.42,5.3L60.6,301.1l-7-4.42-.3-.19a.78.78,0,0,1-.14-.53A2.22,2.22,0,0,1,54.21,294.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.283px 297.638px"
    },
    id: "elk4k7eznx4ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.53,280l3.12-4.93-12.08-7.62h0a1.42,1.42,0,0,0-1.48.07,4.53,4.53,0,0,0-2.2,3.49,1.43,1.43,0,0,0,.52,1.33h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "81.762px 273.638px"
    },
    id: "el252bitz84nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,278.68c0,1.32.85,1.89,2,1.28a4.56,4.56,0,0,0,2.2-3.5c.06-1.31-.85-1.88-2-1.27A4.56,4.56,0,0,0,86,278.68Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "88.1014px 277.575px"
    },
    id: "el1vjcfjlld62",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.24,276.36a.75.75,0,0,1,.62-.08l.16.11,8.42,5.31-2.81,1.47-7-4.42-.3-.18a.79.79,0,0,1-.14-.53A2.23,2.23,0,0,1,88.24,276.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "92.3132px 279.708px"
    },
    id: "elx1nb4fncjwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.17,295.08l-6,3.17,53.72,28a13.75,13.75,0,0,1,5.82,9.55l5.59,48.78a.83.83,0,0,0,1.22.63h0c.29-.15.47-.45.41-1.63l-2.27-51.7a13.34,13.34,0,0,0-4.71-8.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.556px 340.195px"
    },
    id: "elkt6azbz6s4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82,384.39l-44.43-28a6.36,6.36,0,0,1-2.68-5.09l.1-2.67a6.38,6.38,0,0,1,3.07-4.87l46.48-24.47a6.37,6.37,0,0,1,5.75.23l44.43,28a6.34,6.34,0,0,1,2.68,5.08l-.11,2.72a6.35,6.35,0,0,1-3.07,4.86l-46.48,24.46A6.35,6.35,0,0,1,98.82,384.39Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "102.965px 351.96px"
    },
    id: "el2aq202k5wr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxgrhq1lokli"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.64,384.79a4.45,4.45,0,0,1-.82-.4l-44.43-28a6.35,6.35,0,0,1-2.68-5.08l.11-2.68a6.43,6.43,0,0,1,2.51-4.51c-1.06.88-.93,2.11.42,3L99,374.92Z",
    style: {
      opacity: 0.3,
      transformOrigin: "75.675px 364.455px"
    },
    className: "animable",
    id: "elozr6ur5tus"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4xeboj82tw6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.22,352.58l-.11,2.72a6.32,6.32,0,0,1-3.07,4.86l-46.48,24.46a6.43,6.43,0,0,1-4.92.16L99,374.92l.21.14a6.34,6.34,0,0,0,5.75.22l46.48-24.47c1.41-.74,1.64-2,.65-2.91A6.44,6.44,0,0,1,154.22,352.58Z",
    style: {
      opacity: 0.15,
      transformOrigin: "126.61px 366.546px"
    },
    className: "animable",
    id: "elgilsic69fho"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.17,329.22,70.68,353.69a5.94,5.94,0,0,1-3.39.53l-.5-.07-.11,0-.29-.07h0l-.45-.13a4.47,4.47,0,0,1-1-.46L62.65,352A8.07,8.07,0,0,1,59.39,347L54,308.11a4.34,4.34,0,0,1,0-.72,2.83,2.83,0,0,1,0-.29,4.94,4.94,0,0,1,.37-1.39,5.06,5.06,0,0,1,1.6-2.11l.21-.15.31-.18,46.48-24.47a6.38,6.38,0,0,1,5.74.22l2.29,1.45a6.54,6.54,0,0,1,1.34,1.17l.22.27a9.12,9.12,0,0,1,.79,1.16c.06.09.1.18.15.27a2.53,2.53,0,0,1,.12.23c.06.12.11.23.16.35a3.68,3.68,0,0,1,.15.35l.1.28a1,1,0,0,1,0,.14,2.5,2.5,0,0,1,.07.26,2,2,0,0,1,.08.33,1.84,1.84,0,0,1,0,.25l5.4,38.86A5.05,5.05,0,0,1,117.17,329.22Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "86.7954px 316.25px"
    },
    id: "elv5kgee0b34g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88,313.09,67.29,352a2.18,2.18,0,0,0,3.39,1.74l46.48-24.47a5,5,0,0,0,2.48-4.83l-5.4-38.86a2.18,2.18,0,0,0-3.4-1.74L64.36,308.26A5.06,5.06,0,0,0,61.88,313.09Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "90.7617px 318.787px"
    },
    id: "elrh6e9an49y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqto9of9q0yg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.88,313.09,67.29,352a2.18,2.18,0,0,0,3.39,1.74l46.48-24.47a5,5,0,0,0,2.48-4.83l-5.4-38.86a2.18,2.18,0,0,0-3.4-1.74L64.36,308.26A5.06,5.06,0,0,0,61.88,313.09Z",
    style: {
      opacity: 0.15,
      transformOrigin: "90.7617px 318.787px"
    },
    className: "animable",
    id: "elgby4k3quk1m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsh9xm8yq3sq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.49,354.11a6.72,6.72,0,0,1-2.2.11l-.5-.07c-.14,0-.27,0-.4-.09h0l-.45-.13a4.47,4.47,0,0,1-1-.46L62.65,352A8.07,8.07,0,0,1,59.39,347L54,308.11a4.34,4.34,0,0,1,0-.72,2.83,2.83,0,0,1,0-.29,4.94,4.94,0,0,1,.37-1.39l7.93,4.92a4.63,4.63,0,0,0-.39,2.46L67.29,352a2.16,2.16,0,0,0,2.2,2.09Z",
    style: {
      opacity: 0.3,
      transformOrigin: "61.7375px 329.987px"
    },
    className: "animable",
    id: "elesdzot8jl0u"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wheel--inject-57",
    className: "animable",
    style: {
      transformOrigin: "66.3713px 371.785px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.41,323.78l.52,3.67,38.91,25.19a13.69,13.69,0,0,1,4.76,9.78l2.93,51.19a.83.83,0,0,1-1.33.71h0l-15.53-9.88.13-3.35,12.9,8.24-4.1-43.87a13.68,13.68,0,0,0-5.82-9.54L55.24,332.15C51.32,329.59,53,325.79,56.41,323.78Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "78.2535px 369.134px"
    },
    id: "elz263giueje9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,347.69l-1.7-1.08a25,25,0,0,0-11.81-4.19h-.31a16.52,16.52,0,0,0-1.87,0,20.45,20.45,0,0,0-14.3,7.26l-.21.23c-.12.14-.24.28-.35.43l-.23.3c-.1.12-.18.24-.27.36s-.33.48-.49.74l-.17.27-.22.37,0,0a20.46,20.46,0,0,0-2.85,9.68l0,.81c0,.37,0,.76-.06,1.14l-.08,2c-.68,17.43,10.73,39.11,25.49,48.41l1.7,1.08a25,25,0,0,0,11.81,4.18h.24c.24,0,.48,0,.71,0h.23c.2,0,.41,0,.61,0l.3,0,.16,0A20.46,20.46,0,0,0,85.07,412c.16-.19.3-.38.45-.57l0-.07c.16-.23.33-.46.48-.7a20.36,20.36,0,0,0,3.44-10.6l.08-2,.08-2C90.33,378.66,78.92,357,64.16,347.69Zm-8.4,61.44C43.3,401.27,33.67,383,34.24,368.26S45.38,348,57.84,355.83,79.93,382,79.36,396.7,68.22,417,55.76,409.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "59.4221px 381.037px"
    },
    id: "elit5i5m0ckz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92,350.45l-1.7-1.08c-7.3-4.6-14-5.31-19.09-2.75l-.39.21-.1.06-.45.26-.44.29a9.79,9.79,0,0,0-.86.62l-.4.34a7.87,7.87,0,0,0-.79.74c-.13.12-.25.26-.37.39l-.37.41c-.12.14-.24.28-.35.43l-.23.3c-.1.12-.18.24-.27.36s-.33.48-.49.74l-.17.27-.22.37-.2.37c-.24.45-.48.92-.69,1.42-.11.26-.23.52-.32.79,0,0,0,0,0,0-.19.48-.36,1-.52,1.51-.09.28-.17.56-.25.85s-.17.67-.24,1c0,.16-.07.32-.11.49s-.11.56-.16.84l-.15,1a.88.88,0,0,1,0,.16c0,.28-.07.55-.1.84,0,.11,0,.22,0,.34,0,.31-.06.62-.08.94s0,.76-.06,1.14l-.08,2c-.68,17.43,10.73,39.11,25.49,48.41l1.7,1.08a24.77,24.77,0,0,0,12.05,4.2c.24,0,.48,0,.71,0h.23c.2,0,.41,0,.61,0l.3,0c.21,0,.41,0,.61-.06l.53-.07c.18,0,.35-.05.51-.09a9.18,9.18,0,0,0,1-.23l.41-.11.44-.14c.13-.05.25-.08.37-.14a7.68,7.68,0,0,0,.79-.32l.39-.18.1-.05.15-.08.24-.12c5-2.71,8.2-8.67,8.54-17.3l.08-2C85.09,381.42,73.67,359.75,58.92,350.45Zm-3.16,58.68C43.3,401.27,33.67,383,34.24,368.26S45.38,348,57.84,355.83,79.93,382,79.36,396.7,68.22,417,55.76,409.13Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "56.8908px 382.471px"
    },
    id: "elf3zbyzh9lj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.07,406c-3.82,4.2-10.17,4.57-17.2.15-11.07-7-19.64-23.25-19.12-36.34C37,364,39,359.77,42.11,357.51c-2.22,2.42-3.59,6.11-3.78,10.9-.51,13.08,8.05,29.35,19.13,36.34C63.58,408.61,69.19,408.82,73.07,406Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "54.8988px 383.41px"
    },
    id: "eltbgl1nhrmdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr61xqswhav7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.07,406c-3.82,4.2-10.17,4.57-17.2.15-11.07-7-19.64-23.25-19.12-36.34C37,364,39,359.77,42.11,357.51c-2.22,2.42-3.59,6.11-3.78,10.9-.51,13.08,8.05,29.35,19.13,36.34C63.58,408.61,69.19,408.82,73.07,406Z",
    style: {
      opacity: 0.2,
      transformOrigin: "54.8988px 383.41px"
    },
    className: "animable",
    id: "ele5gz7clcnjf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,355.83c-12.46-7.86-23-2.29-23.6,12.42s9.06,33,21.52,40.88,23,2.29,23.59-12.43S70.3,363.69,57.84,355.83Zm-2,50.34c-11.07-7-19.63-23.25-19.12-36.34s9.9-18,21-11S77.36,382,76.85,395.12,67,413.15,55.87,406.17Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "56.7946px 382.484px"
    },
    id: "elgd86khtnhxu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.41,388.59l-.12-.7L58.61,382.4l-.39-.61,13.43-7.07c-.09-.19-.2-.37-.3-.56l-13.42,7.07-.29-.66,5.43-17.51-.51-.49-5.34,17.22-.6-.74L52.9,356.46c-.22-.08-.45-.15-.67-.21l3.66,22.28-.71-.13L43.7,356.59l-.57.28,11.49,21.82-.3.66L37.86,363.56c-.08.22-.15.44-.22.67l16.7,16,.27.92-17.52-5.43c0,.23.07.46.1.69L55,382l.39.61-13.7,7.21c.1.19.19.38.29.56l13.7-7.21.29.66-5.58,18c.17.16.33.33.51.49l5.49-17.71.6.75,3.82,23.24.68.2-3.77-22.93.71.13,11.73,22.29.56-.31L59,385.66l.3-.66,16.6,15.92c.07-.23.13-.45.2-.69L59.28,384.11l-.27-.92Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "56.75px 382.525px"
    },
    id: "eln1vm2o6d1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36,373c-2.14-1.35-4.1-1.5-5.53-.68-.3.18-.66.32-1,.53l-.3.18-.06,0h0a3.57,3.57,0,0,0-.38.3l-.09.08a3.14,3.14,0,0,0-.31.32l-.11.13c-.09.11-.17.23-.25.35a1.37,1.37,0,0,0-.13.2l-.19.35-.12.28c0,.12-.1.23-.14.35s-.07.25-.11.37l-.09.33c0,.16-.06.33-.09.5s0,.19,0,.28a7.88,7.88,0,0,0-.07.86,17,17,0,0,0,7.17,13.62,8.81,8.81,0,0,0,.77.44,4.43,4.43,0,0,0,.45.2l.31.14.31.1.43.14.17,0a5.3,5.3,0,0,0,.55.1h0A4,4,0,0,0,62,392l1.15-.58c1.38-.77,2.28-2.44,2.37-4.84A17,17,0,0,0,58.36,373Zm-2.78,14.7c-1.27-1.08-3-4.27-3.66-6a15.67,15.67,0,0,0,1.31.87c2,1.12,2-.29,2.74.72s.53,3.38-.16,4.59A1.28,1.28,0,0,1,55.58,387.67Zm4.26-9a2.52,2.52,0,0,0-.33.13l-1.21.63a1.4,1.4,0,0,0-.61.56,10.7,10.7,0,0,1-1.83-5.83,12.82,12.82,0,0,1,4.88,4.11,1.19,1.19,0,0,1,.08.22A4.42,4.42,0,0,0,59.84,378.71ZM54,377.46c.56,2.35,1.52,2.75,1.55,3.51-1.5-.31-3.91-1.87-4-3.34a5.79,5.79,0,0,1,1.48-3.85C53.69,374.09,53.59,375.54,54,377.46Zm3.88,12.37c-.78-.77.14-1.44.61-2.94a4.08,4.08,0,0,0,.06-2.21c1.53,1.3,3.77,4.66,3.12,5.61l-.08.09C60.29,390.67,58.45,390.37,57.92,389.83Zm3.95-4.91c-1.59-2.3-2.28-1.56-2.64-2.77a1.53,1.53,0,0,1,.61-1.58,2,2,0,0,1,2.39.91,14.65,14.65,0,0,1,1.09,5.79C62.94,386.65,62.47,385.79,61.87,384.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "57.455px 382.159px"
    },
    id: "elck1i9v330k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrmg9v8qyss"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.36,373c-2.14-1.35-4.1-1.5-5.53-.68-.3.18-.66.32-1,.53l-.3.18-.06,0h0a3.57,3.57,0,0,0-.38.3l-.09.08a3.14,3.14,0,0,0-.31.32l-.11.13c-.09.11-.17.23-.25.35a1.37,1.37,0,0,0-.13.2l-.19.35-.12.28c0,.12-.1.23-.14.35s-.07.25-.11.37l-.09.33c0,.16-.06.33-.09.5s0,.19,0,.28a7.88,7.88,0,0,0-.07.86,17,17,0,0,0,7.17,13.62,8.81,8.81,0,0,0,.77.44,4.43,4.43,0,0,0,.45.2l.31.14.31.1.43.14.17,0a5.3,5.3,0,0,0,.55.1h0A4,4,0,0,0,62,392l1.15-.58c1.38-.77,2.28-2.44,2.37-4.84A17,17,0,0,0,58.36,373Zm-2.78,14.7c-1.27-1.08-3-4.27-3.66-6a15.67,15.67,0,0,0,1.31.87c2,1.12,2-.29,2.74.72s.53,3.38-.16,4.59A1.28,1.28,0,0,1,55.58,387.67Zm4.26-9a2.52,2.52,0,0,0-.33.13l-1.21.63a1.4,1.4,0,0,0-.61.56,10.7,10.7,0,0,1-1.83-5.83,12.82,12.82,0,0,1,4.88,4.11,1.19,1.19,0,0,1,.08.22A4.42,4.42,0,0,0,59.84,378.71ZM54,377.46c.56,2.35,1.52,2.75,1.55,3.51-1.5-.31-3.91-1.87-4-3.34a5.79,5.79,0,0,1,1.48-3.85C53.69,374.09,53.59,375.54,54,377.46Zm3.88,12.37c-.78-.77.14-1.44.61-2.94a4.08,4.08,0,0,0,.06-2.21c1.53,1.3,3.77,4.66,3.12,5.61l-.08.09C60.29,390.67,58.45,390.37,57.92,389.83Zm3.95-4.91c-1.59-2.3-2.28-1.56-2.64-2.77a1.53,1.53,0,0,1,.61-1.58,2,2,0,0,1,2.39.91,14.65,14.65,0,0,1,1.09,5.79C62.94,386.65,62.47,385.79,61.87,384.92Z",
    style: {
      opacity: 0.2,
      transformOrigin: "57.455px 382.159px"
    },
    className: "animable",
    id: "elpxqclrnt6ri"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.15,373.59c-4.16-2.61-7.68-.76-7.87,4.15a17,17,0,0,0,7.17,13.62c4.15,2.62,7.67.76,7.86-4.14A17,17,0,0,0,57.15,373.59Zm-1.93.45c1.52.08,5.06,3.19,5.52,4.27s-.86.63-2.1,1c-1.58.49-.9,2-1.8,1.61C55.52,380.33,53.7,374,55.22,374Zm-2.28-.32c.77.16.62,1.69,1.1,3.74.62,2.6,1.73,2.81,1.53,3.76-.29,1.4-5-.89-5.2-3S52.16,373.55,52.94,373.72Zm1.44,14.57c-1.61-1.36-4-6.09-3.94-7.07s1.25.42,2.79,1.29c2,1.12,2-.29,2.74.72C57.12,384.69,56,389.65,54.38,388.29Zm7.33,2c-.85,1.23-4.23.92-5,.16s.15-1.44.62-2.95c.59-1.9-.51-3,.17-3.32C58.48,383.7,62.55,389.05,61.71,390.29Zm-1-4.76c-1.59-2.29-2.28-1.55-2.64-2.76-.53-1.77,3.11-3.41,4.2-1.29s1.34,6.67.85,7.17S61.92,387.34,60.67,385.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "56.795px 382.477px"
    },
    id: "elnn03z645wfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.69,385.2c1.27.8,2.35.23,2.41-1.27a5.21,5.21,0,0,0-2.2-4.17c-1.27-.8-2.34-.23-2.4,1.27A5.2,5.2,0,0,0,56.69,385.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "56.8px 382.48px"
    },
    id: "ele7e3q1bf8sn",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ball--inject-57",
    className: "animable",
    style: {
      transformOrigin: "401.287px 387.664px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ball--inject-57",
    className: "animable",
    style: {
      transformOrigin: "401.287px 387.664px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.05,378.19a48.18,48.18,0,1,0,56.72-37.75A48.18,48.18,0,0,0,354.05,378.19Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "401.287px 387.677px"
    },
    id: "eloou4bbyskho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb1axur3bad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.05,378.19a48.18,48.18,0,1,0,56.72-37.75A48.18,48.18,0,0,0,354.05,378.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "401.287px 387.677px"
    },
    className: "animable",
    id: "el79op3msvack"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.5,350.3c-.47,2.32-2.44,4.18-5.56,5.23a22.9,22.9,0,0,1-20.32-4.08c-2.47-2.17-3.57-4.65-3.11-7,.43-2.13,2.13-3.86,4.81-5,1,0,2.06,0,3.1,0a16.65,16.65,0,0,0-2.08.53c-2.82.95-4.6,2.59-5,4.6s.6,4.22,2.83,6.18c4.75,4.19,13.5,5.94,19.5,3.92,2.82-.95,4.6-2.59,5-4.61s-.6-4.21-2.83-6.18a16.34,16.34,0,0,0-2.25-1.62c1,.37,2,.78,3,1.21C422.92,345.66,424,348.05,423.5,350.3Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "409.014px 347.909px"
    },
    id: "elecfnskxixuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,407.19l.08-.17h0Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "445.38px 407.105px"
    },
    id: "elja1un2epmfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.06,366.39c-.07.15-.15.29-.22.44C357.91,366.68,358,366.54,358.06,366.39Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "357.95px 366.61px"
    },
    id: "elhu6alkepog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.76,408.48l-.34.69Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "444.59px 408.825px"
    },
    id: "elv95kpbea2qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,402.9a33,33,0,0,0,7.34,8.86c15.72,13.83,44.63,19.63,64.47,12.95a33.19,33.19,0,0,0,10.19-5.35q-1.32,1.51-2.76,2.91a37.78,37.78,0,0,1-7.16,3.23c-10.05,3.39-22.39,3.61-34.21,1.24s-23.13-7.35-31.09-14.35a37.8,37.8,0,0,1-5.35-5.74C356.48,405.42,356,404.17,355.58,402.9Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "396.58px 415.607px"
    },
    id: "eld1w3nfvwupk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.07,397.31c16.53,14.56,47,20.67,67.84,13.62,7.93-2.67,13.54-6.91,16.26-12.17-.23.95-.47,1.89-.75,2.81h0c-3.15,4.33-8.35,7.83-15.25,10.16-10.56,3.56-23.54,3.8-36,1.3s-24.32-7.72-32.69-15.09c-5.46-4.81-8.91-10.05-10.14-15.26.1-.95.24-1.91.4-2.86C354.24,385.71,357.79,391.79,364.07,397.31Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "400.755px 397.255px"
    },
    id: "el30ygdt9rpj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.16,390.14c0,.2,0,.39,0,.58C353.19,390.53,353.17,390.34,353.16,390.14Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "353.168px 390.43px"
    },
    id: "elemgh6aayc3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,348.69l-.43.32Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "372.785px 348.85px"
    },
    id: "elppz5oh3q1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.11,382.65c-8.82,3-19.65,3.18-30,1.09s-20.3-6.44-27.28-12.59C369,366.07,366,360.42,365.91,355c.28-.3.58-.6.87-.9-.3,5.49,2.67,11.26,8.57,16.46,13.77,12.12,39.11,17.2,56.49,11.34,7.45-2.52,12.42-6.69,14.26-11.87.15.39.31.77.46,1.16C444.4,376.17,439.39,380.2,432.11,382.65Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "406.235px 369.617px"
    },
    id: "elw78m4v49jnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.26,383.11c-2.11,6.12-7.91,11-16.56,13.93-9.85,3.33-21.95,3.55-33.54,1.22s-22.66-7.2-30.46-14.07c-6.86-6-10.31-12.79-9.9-19.25.36-.66.72-1.3,1.1-1.94-1.34,6.77,2,14.07,9.35,20.57,15.4,13.55,43.74,19.24,63.18,12.68,9.3-3.14,15.18-8.59,16.57-15.35.1.73.19,1.47.26,2.21Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "404.014px 381.403px"
    },
    id: "elo2qixfaj0we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.42,385.42c0-.31,0-.63-.05-.94C449.39,384.79,449.41,385.1,449.42,385.42Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "449.395px 384.95px"
    },
    id: "elhcuw0hyom3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.34,347.74l.43-.29Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "374.555px 347.595px"
    },
    id: "elm1op7okirzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,368.24c-6.74,2.28-15,2.43-23,.83s-15.51-4.92-20.84-9.62c-4.85-4.26-7.21-9.05-6.77-13.61l.92-.52c-.7,4.46,1.55,9.23,6.4,13.5,10.47,9.22,29.75,13.09,43,8.63,6.12-2.07,10.05-5.6,11.12-10,.22.27.43.55.64.83C438.11,362.67,434.08,366.18,428,368.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "408.404px 357.727px"
    },
    id: "el1lz7j6zyuhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,363.14l-.34-.56Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "442.58px 362.86px"
    },
    id: "el2cglyquxq6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.26,360.77c.11.17.22.35.34.52C441.48,361.12,441.37,360.94,441.26,360.77Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "441.43px 361.03px"
    },
    id: "el1n1mir0667n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el95snxy34t3p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.57,415.26c28.7-11,33-32.19,30.72-49.26h0a48.18,48.18,0,1,1-90.92,26.86C355.58,407.64,384.89,426.28,413.57,415.26Z",
    style: {
      fill: "#3293C4",
      opacity: 0.6,
      transformOrigin: "401.411px 400.939px"
    },
    className: "animable",
    id: "elaskqy5bsiwu"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltauc7q2qjkp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.31,344.87a24,24,0,0,0-12.42,1.18,41.11,41.11,0,0,0-10.34,5.2q-.94.66-1.83,1.38c2.76,5.7,6.16,11.16,11.08,15l1.4-.7a138,138,0,0,1,12.88-5.19c3.11-1.18,6.78-2.44,7.75-6C409.46,349.82,404.49,345.92,399.31,344.87ZM376,365.59a36.53,36.53,0,0,1-4.3-6.35c-.42-.82-.81-1.67-1.18-2.52a30.88,30.88,0,0,0-5.24,8.49A14.46,14.46,0,0,0,364,373c.65,3.87,3.68,4.87,7.09,3.54a13.88,13.88,0,0,0,3.35-2.13,47.07,47.07,0,0,1,6.38-4.1A26.83,26.83,0,0,1,376,365.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "386.026px 360.814px"
    },
    className: "animable",
    id: "elbybsnlayi1l"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandTreat);
export default __webpack_public_path__ + "static/media/LandTreat.2c143f566f6ef9dc41d14b7ac8bab917.svg";
export { ForwardRef as ReactComponent };